(function () {
  // ============================================
  // CONFIGURATOR NAV STICKY TOP (<sticky-header>)
  // ============================================
  function getConfiguratorNav() {
    return document.getElementById("configurator-nav");
  }

  function getConfiguratorScrollOffset() {
    const nav = getConfiguratorNav();
    const stickyTop = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--configurator-nav-sticky-top"
      )
    );
    const navHeight = nav ? nav.offsetHeight : 0;
    const total = (!Number.isNaN(stickyTop) ? stickyTop : 0) + navHeight;
    return total > 0 ? total : 140;
  }

  /** True when element is the visible sticky/fixed chrome at the top of the viewport. */
  function isPinnedTopChrome(rect) {
    return rect.height > 0 && rect.bottom > 0 && rect.top < 160;
  }

  function updateConfiguratorNavStickyTop() {
    const nav = getConfiguratorNav();
    if (!nav) return;

    let top = 0;

    const announcementSection = document
      .querySelector(".slider-announcement-wrapper")
      ?.closest('[id^="shopify-section-"]');

    const sectionHeader = document.querySelector(".section-header");
    const stickyHeader = document.querySelector("sticky-header");
    const headerHidden = sectionHeader?.classList.contains(
      "shopify-section-header-hidden"
    );

    // Use viewport bottom edge only — offsetHeight includes hidden mega-menu DOM
    if (announcementSection) {
      const annRect = announcementSection.getBoundingClientRect();
      if (isPinnedTopChrome(annRect)) {
        top = Math.max(top, Math.ceil(annRect.bottom));
      }
    }

    if (!headerHidden && stickyHeader) {
      const headerRect = stickyHeader.getBoundingClientRect();
      if (isPinnedTopChrome(headerRect)) {
        top = Math.max(top, Math.ceil(headerRect.bottom));
      }
    }

    if (top === 0 && !headerHidden) {
      const cssHeaderHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height"
        )
      );
      if (!Number.isNaN(cssHeaderHeight) && cssHeaderHeight > 0) {
        top = Math.ceil(cssHeaderHeight);
        if (announcementSection) {
          const annRect = announcementSection.getBoundingClientRect();
          if (annRect.top < 160 && annRect.height > 0) {
            top += Math.ceil(annRect.height);
          }
        }
      }
    }

    const topPx = `${top}px`;
    document.documentElement.style.setProperty(
      "--configurator-nav-sticky-top",
      topPx
    );
    nav.style.setProperty("top", topPx);
    document.documentElement.style.setProperty(
      "--configurator-scroll-offset",
      `${top + nav.offsetHeight}px`
    );
  }

  let stickyTopRaf = null;
  function scheduleConfiguratorNavStickyTop() {
    if (stickyTopRaf) cancelAnimationFrame(stickyTopRaf);
    stickyTopRaf = requestAnimationFrame(() => {
      stickyTopRaf = null;
      updateConfiguratorNavStickyTop();
      syncActiveNav();
      refreshConfiguratorNavObserver();
    });
  }

  let configuratorNavStickyBound = false;
  function initConfiguratorNavSticky() {
    const nav = getConfiguratorNav();
    if (!nav || configuratorNavStickyBound) return;
    configuratorNavStickyBound = true;

    updateConfiguratorNavStickyTop();

    window.addEventListener("resize", scheduleConfiguratorNavStickyTop);
    window.addEventListener("scroll", scheduleConfiguratorNavStickyTop, {
      passive: true,
    });
    window.addEventListener("load", updateConfiguratorNavStickyTop);

    const announcementSection = document
      .querySelector(".slider-announcement-wrapper")
      ?.closest('[id^="shopify-section-"]');
    const sectionHeader = document.querySelector(".section-header");
    const stickyHeader = document.querySelector("sticky-header");

    if (typeof ResizeObserver !== "undefined") {
      const resizeObserver = new ResizeObserver(
        scheduleConfiguratorNavStickyTop
      );
      [announcementSection, stickyHeader].forEach((el) => {
        if (el) resizeObserver.observe(el);
      });
    }

    stickyHeader?.addEventListener(
      "transitionend",
      scheduleConfiguratorNavStickyTop
    );
    sectionHeader?.addEventListener(
      "transitionend",
      scheduleConfiguratorNavStickyTop
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initConfiguratorNavSticky);
  } else {
    initConfiguratorNavSticky();
  }

  // ============================================
  // DOM ELEMENTS
  // ============================================
  const categories = document.querySelectorAll(".config-category");
  const navItems = document.querySelectorAll(".configurator-nav .nav-item");
  const navScroll = document.getElementById("nav-scroll");
  const prevBtn = document.querySelector(".nav-prev");
  const nextBtn = document.querySelector(".nav-next");

  // Summary overlay elements
  const expandedPanel = document.getElementById("summary-expanded-panel");
  const customBtn = document.getElementById("btn-custom");
  const addToCartBtn = document.getElementById("btn-add-to-cart");
  const breakdownContainer = document.getElementById("summary-breakdown");

  // ============================================
  // STATE
  // ============================================
  let basePrice = 0;
  let isExpanded = false;
  let msrpAutoExpandedOnDock = false;
  let adapterVariantId = null;
  let adapterPrice = 0;
  let eqamVariantId = null;
  let eqamPrice = 0;

  let optionLightboxSwiper = null;

  let currentConfiguration = {
    engine: null,
    heater: null,
    glass: null,
    glassType: "jacuzzi",
    mouthpiece: null,
    needsAdapter: false,
    needsEqam: false,
    carb: null,
    accessories: [],
  };

  // ============================================
  // NAVIGATION - STICKY TABS
  // ============================================
  let activeNavLockUntil = 0;

  function getCategoryHeaderRect(category) {
    const header = category.querySelector(".config-category-header");
    return (header || category).getBoundingClientRect();
  }

  function getConfiguratorNavBottom() {
    // Always use the nav's sticky-state bottom (sticky-top + height) regardless of
    // whether the nav has reached its sticky point yet. Using getBoundingClientRect().bottom
    // gives a wildly different value before the nav is sticky, causing scroll to land wrong
    // and finalizeAlignment to overcorrect (scroll to top).
    return getConfiguratorScrollOffset();
  }

  function syncActiveCategoryHighlight(activeId) {
    if (!activeId) return;

    categories.forEach((cat) => {
      cat.classList.toggle("is-step-active", cat.id === activeId);
    });
  }

  function syncActiveNav() {
    if (isMobileAccordion()) return;
    if (Date.now() < activeNavLockUntil || !categories.length) return;

    const nav = getConfiguratorNav();
    if (!nav) return;

    const navBottom = nav.getBoundingClientRect().bottom;
    let activeId = categories[0].id;

    for (let i = 0; i < categories.length; i++) {
      const sectionRect = categories[i].getBoundingClientRect();
      const transitionY = sectionRect.top + sectionRect.height * 0.5;

      if (transitionY < navBottom) {
        if (categories[i + 1]) {
          activeId = categories[i + 1].id;
        } else {
          activeId = categories[i].id;
        }
      } else {
        activeId = categories[i].id;
        break;
      }
    }

    navItems.forEach((item) => {
      item.classList.toggle("active", item.getAttribute("href") === `#${activeId}`);
    });

    syncActiveCategoryHighlight(activeId);
  }

  navItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = item.getAttribute("href");
      const targetCategory = document.querySelector(targetId);

      if (targetCategory) {
        if (isMobileAccordion()) {
          openAccordionStep(targetCategory, { scroll: true, syncNav: true });
          return;
        }

        const offset = getConfiguratorNavBottom();
        const scrollAnchor =
          targetCategory.querySelector(".config-category-header") ||
          targetCategory;
        const elementPosition = scrollAnchor.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });

        navItems.forEach((n) => n.classList.remove("active"));
        item.classList.add("active");
        syncActiveCategoryHighlight(targetCategory.id);
        scrollNavItemIntoView(item);
        activeNavLockUntil = Date.now() + 800;
      }
    });
  });

  // ============================================
  // HORIZONTAL SCROLL WITH ARROWS + VISIBILITY
  // ============================================

  function scrollNavItemIntoView(navItem) {
    if (!navScroll || !navItem) return;

    const items = Array.from(navItems);
    const index = items.indexOf(navItem);
    if (index === -1) return;

    const maxScrollLeft = Math.max(0, navScroll.scrollWidth - navScroll.clientWidth);
    const containerRect = navScroll.getBoundingClientRect();
    const itemRect = navItem.getBoundingClientRect();
    const itemScrollLeft = navScroll.scrollLeft + (itemRect.left - containerRect.left);
    let targetScrollLeft;

    if (index === 0) {
      targetScrollLeft = 0;
    } else if (index === items.length - 1) {
      targetScrollLeft = maxScrollLeft;
    } else {
      targetScrollLeft = itemScrollLeft - (navScroll.clientWidth - itemRect.width) / 2;
    }

    targetScrollLeft = Math.max(0, Math.min(maxScrollLeft, targetScrollLeft));

    navScroll.scrollTo({ left: targetScrollLeft, behavior: "smooth" });
  }

  function updateArrowVisibility() {
    if (!navScroll || !prevBtn || !nextBtn) return;

    const scrollLeft = navScroll.scrollLeft;
    const maxScrollLeft = Math.max(0, navScroll.scrollWidth - navScroll.clientWidth);

    prevBtn.classList.toggle("nav-arrow--hidden", scrollLeft <= 1);
    nextBtn.classList.toggle("nav-arrow--hidden", scrollLeft >= maxScrollLeft - 1);
  }

  window.addEventListener("load", updateArrowVisibility);
  window.addEventListener("resize", updateArrowVisibility);
  requestAnimationFrame(updateArrowVisibility);

  if (prevBtn && navScroll) {
    prevBtn.addEventListener("click", () => {
      navScroll.scrollBy({ left: -200, behavior: "smooth" });
    });
  }
  if (nextBtn && navScroll) {
    nextBtn.addEventListener("click", () => {
      navScroll.scrollBy({ left: 200, behavior: "smooth" });
    });
  }

  if (navScroll) {
    navScroll.addEventListener("scroll", updateArrowVisibility);
  }

  // ============================================
  // MOBILE STEP ACCORDION (<= 749px)
  // ============================================
  const MOBILE_ACCORDION_MQ = window.matchMedia("(max-width: 749px)");
  let mobileAccordionInitialized = false;

  function isMobileAccordion() {
    return MOBILE_ACCORDION_MQ.matches;
  }

  function isCategoryVisible(categoryEl) {
    if (!categoryEl) return false;
    return categoryEl.offsetParent !== null && getComputedStyle(categoryEl).display !== "none";
  }

  function getVisibleCategories() {
    return Array.from(categories).filter(isCategoryVisible);
  }

  function getCategoryFromInput(input) {
    return input ? input.closest(".config-category") : null;
  }

  function getCategoryStepKey(categoryEl) {
    return categoryEl?.dataset?.category || categoryEl?.id || "";
  }

  function getNextCategory(categoryEl) {
    const list = getVisibleCategories();
    const idx = list.indexOf(categoryEl);
    return idx >= 0 && idx < list.length - 1 ? list[idx + 1] : null;
  }

  function getPreferredScrollBehavior(preferred = "smooth") {
    if (preferred === "auto") return "auto";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return "auto";
    return "smooth";
  }

  function scrollCategoryIntoView(categoryEl, behavior = "smooth") {
    if (!categoryEl) return;

    const scrollAnchor =
      categoryEl.querySelector(".config-category-header") || categoryEl;
    const SCROLL_ALIGN_TOLERANCE = 12;
    const scrollBehavior = getPreferredScrollBehavior(behavior);

    function getHeaderDrift() {
      const offset = getConfiguratorNavBottom();
      return scrollAnchor.getBoundingClientRect().top - offset;
    }

    function isAligned() {
      return Math.abs(getHeaderDrift()) <= SCROLL_ALIGN_TOLERANCE;
    }

    function scrollToAligned(alignBehavior) {
      if (isAligned()) return false;

      window.scrollTo({
        top: Math.max(0, window.pageYOffset + getHeaderDrift()),
        behavior: getPreferredScrollBehavior(alignBehavior),
      });
      return true;
    }

    function finalizeAlignment() {
      requestAnimationFrame(() => {
        if (!isAligned()) scrollToAligned("auto");
      });
    }

    // After the primary scroll settles, watch the media stage above the
    // configurator for resize events caused by async 3D-model / image
    // loading. On mobile the media stage is stacked vertically above the
    // steps, so a height change shifts all step headers. If the user hasn't
    // manually scrolled away we correct the alignment automatically.
    function watchPostScrollLayoutShift() {
      if (!isMobileAccordion()) return;
      const mediaStage =
        document.querySelector(".configurator-media-stage") ||
        document.querySelector(".product__media-wrapper");
      if (!mediaStage) return;

      const baseScrollY = window.scrollY;
      const USER_SCROLL_THRESHOLD = 40; // px – more means the user scrolled manually

      const ro = new ResizeObserver(() => {
        if (Math.abs(window.scrollY - baseScrollY) > USER_SCROLL_THRESHOLD) {
          ro.disconnect();
          return;
        }
        const drift = getHeaderDrift();
        if (Math.abs(drift) > SCROLL_ALIGN_TOLERANCE) {
          window.scrollTo({
            top: Math.max(0, window.scrollY + drift),
            behavior: "smooth",
          });
        }
      });

      ro.observe(mediaStage);
      // Stop watching after 3 s — model loading is always done by then.
      setTimeout(() => ro.disconnect(), 3000);
    }

    function afterPrimaryScroll() {
      if (scrollBehavior === "smooth" && "onscrollend" in window) {
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          window.removeEventListener("scrollend", finish);
          finalizeAlignment();
          watchPostScrollLayoutShift();
        };

        window.addEventListener("scrollend", finish, { once: true });
        setTimeout(finish, 600);
        return;
      }

      setTimeout(() => {
        finalizeAlignment();
        watchPostScrollLayoutShift();
      }, scrollBehavior === "smooth" ? 450 : 0);
    }

    // Call synchronously: getBoundingClientRect forces reflow so accordion
    // class changes (display:none) are already in effect. Starting the scroll
    // before the next paint avoids a visible "layout flash" intermediate frame.
    if (!scrollToAligned(scrollBehavior)) return;
    afterPrimaryScroll();
  }

  function updateContinueButtons() {
    if (!isMobileAccordion()) return;

    categories.forEach((cat) => {
      const btn = cat.querySelector(".configurator-step-continue");
      if (!btn) return;

      const isOpen = cat.classList.contains("is-accordion-open");
      const hasNext = Boolean(getNextCategory(cat));
      btn.hidden = !(isOpen && hasNext);
    });

    updateAccordionSelectedSummaries();
  }

  function getOptionTitleFromInput(input) {
    if (!input) return null;

    const option = input.closest(".config-option");
    if (!option || getComputedStyle(option).display === "none") return null;

    const titleEl = option.querySelector(".option-title");
    return titleEl?.textContent?.trim() || null;
  }

  function getCategorySelectedLabel(categoryEl) {
    if (getCategoryStepKey(categoryEl) === "accessories") return null;

    const optionsRoot = categoryEl.querySelector(".config-options");
    if (!optionsRoot) return null;

    const checkedRadio = optionsRoot.querySelector('input[type="radio"]:checked');
    if (!checkedRadio) return null;

    return getOptionTitleFromInput(checkedRadio);
  }

  function ensureAccordionSelectedSummaries() {
    categories.forEach((cat) => {
      const header = cat.querySelector(".config-category-header");
      if (!header || header.querySelector(".config-category-selected-summary")) return;

      const summary = document.createElement("p");
      summary.className = "config-category-selected-summary";
      summary.setAttribute("aria-live", "polite");

      const headingRow = header.querySelector(".config-category-heading-row");
      if (headingRow) {
        headingRow.insertAdjacentElement("afterend", summary);
      } else {
        header.prepend(summary);
      }
    });
  }

  function updateAccordionSelectedSummaries() {
    if (!isMobileAccordion()) return;

    categories.forEach((cat) => {
      const summary = cat.querySelector(".config-category-selected-summary");
      if (!summary) return;

      const label = getCategorySelectedLabel(cat);
      summary.textContent = label ? `Selected: ${label}` : "";
    });
  }

  function shouldAutoAdvanceFromCategory(categoryEl) {
    const key = getCategoryStepKey(categoryEl);
    return Boolean(key) && key !== "accessories";
  }

  function activateDesktopStep(categoryEl, { scroll = true, behavior = "smooth" } = {}) {
    if (isMobileAccordion() || !categoryEl) return;

    navItems.forEach((item) => {
      item.classList.toggle("active", item.getAttribute("href") === `#${categoryEl.id}`);
    });

    syncActiveCategoryHighlight(categoryEl.id);

    const activeNav = document.querySelector(".configurator-nav .nav-item.active");
    if (activeNav) scrollNavItemIntoView(activeNav);

    activeNavLockUntil = Date.now() + 800;

    if (scroll) {
      scrollCategoryIntoView(categoryEl, behavior);
    }
  }

  function ensureContinueButtons() {
    categories.forEach((cat) => {
      if (cat.querySelector(".configurator-step-continue")) return;
      if (!getNextCategory(cat)) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "configurator-step-continue";
      btn.textContent = "Continue";
      btn.hidden = true;
      btn.addEventListener("click", () => {
        advanceToNextStep(cat);
      });

      const options = cat.querySelector(".config-options");
      if (options) options.insertAdjacentElement("afterend", btn);
    });
  }

  function openAccordionStep(
    categoryEl,
    { scroll = true, behavior = "smooth", syncNav = true } = {}
  ) {
    if (!categoryEl || !isMobileAccordion()) return;

    categories.forEach((cat) => {
      const isOpen = cat === categoryEl;
      cat.classList.toggle("is-accordion-open", isOpen);
      cat.classList.toggle("is-accordion-collapsed", !isOpen);
    });

    activeNavLockUntil = Date.now() + 900;

    if (syncNav) {
      navItems.forEach((item) => {
        item.classList.toggle("active", item.getAttribute("href") === `#${categoryEl.id}`);
      });
      const activeNav = document.querySelector(".configurator-nav .nav-item.active");
      if (activeNav) scrollNavItemIntoView(activeNav);
    }

    syncActiveCategoryHighlight(categoryEl.id);

    updateContinueButtons();

    if (scroll) {
      scrollCategoryIntoView(categoryEl, behavior);
    }
  }

  function advanceToNextStep(currentCategory) {
    const next = getNextCategory(currentCategory);
    if (!next) return;

    if (isMobileAccordion()) {
      openAccordionStep(next, { scroll: true, behavior: "smooth", syncNav: true });
      return;
    }

    activateDesktopStep(next, { scroll: true, behavior: "smooth" });
  }

  function handleStepOptionChange(input) {
    // During a preset apply, four synthetic changes fire back-to-back and each
    // auto-advance issues its own window.scrollTo -- they cancel the apply's single
    // scroll-to-builder (and each other). The apply scrolls once at the end instead.
    if (window.__eqcApplyingBuild) return;
    const category = getCategoryFromInput(input);
    if (!category || !shouldAutoAdvanceFromCategory(category)) return;

    if (isMobileAccordion()) {
      if (!category.classList.contains("is-accordion-open")) return;
      advanceToNextStep(category);
      return;
    }

    advanceToNextStep(category);
  }

  function bindMobileAccordionHeaders() {
    categories.forEach((cat) => {
      const header = cat.querySelector(".config-category-header");
      if (!header || header.dataset.accordionBound === "true") return;

      header.dataset.accordionBound = "true";
      header.classList.add("configurator-accordion-header");

      header.addEventListener("click", (e) => {
        if (!isMobileAccordion()) return;
        if (cat.classList.contains("is-accordion-open")) return;

        openAccordionStep(cat, { scroll: true, syncNav: true });
      });
    });
  }

  function activateMobileAccordion() {
    initMobileAccordion();
    const defaultCategory =
      document.getElementById("category-engine") || getVisibleCategories()[0];
    if (defaultCategory) {
      openAccordionStep(defaultCategory, {
        scroll: false,
        behavior: "auto",
        syncNav: true,
      });
    }
  }

  function deactivateMobileAccordion() {
    categories.forEach((cat) => {
      cat.classList.remove("is-accordion-open", "is-accordion-collapsed", "is-step-active");
    });

    document
      .getElementById("configurator-categories")
      ?.classList.remove("configurator-categories--mobile-accordion");

    document.querySelectorAll(".configurator-step-continue").forEach((btn) => {
      btn.hidden = true;
    });

    refreshConfiguratorNavObserver();
  }

  function initMobileAccordion() {
    if (mobileAccordionInitialized) return;
    mobileAccordionInitialized = true;

    document
      .getElementById("configurator-categories")
      ?.classList.add("configurator-categories--mobile-accordion");

    ensureContinueButtons();
    ensureAccordionSelectedSummaries();
    bindMobileAccordionHeaders();

    if (typeof MOBILE_ACCORDION_MQ.addEventListener === "function") {
      MOBILE_ACCORDION_MQ.addEventListener("change", (event) => {
        if (event.matches) {
          activateMobileAccordion();
        } else {
          deactivateMobileAccordion();
        }
      });
    }
  }

  // ============================================
  // UPDATE ACTIVE NAV ON SCROLL
  // ============================================
  let categoryNavObserver = null;

  function refreshConfiguratorNavObserver() {
    if (!categories.length) return;

    if (categoryNavObserver) {
      categoryNavObserver.disconnect();
      categoryNavObserver = null;
    }

    const offset = getConfiguratorNavBottom();
    categoryNavObserver = new IntersectionObserver(() => {
      syncActiveNav();
    }, {
      threshold: [0, 0.1, 0.5],
      rootMargin: `-${offset}px 0px -60% 0px`,
    });

    categories.forEach((category) => categoryNavObserver.observe(category));
    syncActiveNav();
  }

  // Update all configuration change handlers
function handleEngineChange(selectedInput) {
  currentConfiguration.engine = selectedInput.dataset.variantId;
  updateSummary();
  updateMainProductMedia(); // Add this
}

  // ============================================
  // HEATER MANAGEMENT WITH EQAM
  // ============================================

  function handleHeaterChange(selectedInput) {
    currentConfiguration.heater = selectedInput.dataset.variantId;

    const needsEqam = selectedInput.dataset.needsEqam === "true";
    currentConfiguration.needsEqam = needsEqam;

    // Dynamically update EQAM variant ID from selected heater
    if (needsEqam && selectedInput.dataset.eqamVariantId) {
      eqamVariantId = selectedInput.dataset.eqamVariantId;
      eqamPrice = parseFloat(selectedInput.dataset.eqamPrice || 0);
      console.log("EQAM updated from heater selection:", eqamVariantId, eqamPrice);
    }

    console.log("Heater changed to:", {
      variantId: selectedInput.dataset.variantId,
      needsEqam: needsEqam,
      eqamVariantId: eqamVariantId,
    });

    updateEqamDisplay();
    updateHeaterOptions();
    updateSummary();
    updateMainProductMedia(); // Add this
  }

  function updateEqamDisplay() {
    const eqamDisplay = document.getElementById("eqam-display");
    if (!eqamDisplay) return;
    // Keep out of the option grid; title/SKU for cart & summary come from dataset + heater subline note.
    eqamDisplay.style.display = "none";
  }

  function updateHeaterOptions() {
    const heaterOptions = document.querySelectorAll('input[name="heater"]');
    const eqamDisplay = document.getElementById("eqam-display");
    let eqamTitle = "EQ Heater for Crucibles";
    let eqamSku = "EQAM";

    if (eqamDisplay) {
      const eqamTitleElement = eqamDisplay.querySelector(".option-title");
      if (eqamTitleElement) {
        eqamTitle = eqamTitleElement.textContent.trim();
      }
      eqamSku = eqamDisplay.dataset.eqamSku || "EQAM";
    }

    heaterOptions.forEach((option) => {
      const label = option.closest(".config-option");

      if (!label) return;

      const existingNote = label.querySelector(".auto-included-note");
      if (existingNote) existingNote.remove();

      const needsEqam = option.dataset.needsEqam === "true";

      if (needsEqam) {
        const autoIncludedNote = document.createElement("span");
        autoIncludedNote.className = "auto-included-note";
        autoIncludedNote.style.cssText =
          "font-size: 11px; color: #000; display: block; margin-top: 4px; font-weight: 500;";
        autoIncludedNote.innerHTML = `✓ ${eqamTitle} will be included`;

        const optionInfo = label.querySelector(".option-info");
        if (optionInfo) {
          optionInfo.appendChild(autoIncludedNote);
        }
      }
    });
  }

  function initializeEqam() {
    const eqamDisplay = document.getElementById("eqam-display");
    if (eqamDisplay) {
      eqamVariantId = eqamDisplay.dataset.eqamVariantId;
      eqamPrice = parseFloat(eqamDisplay.dataset.eqamPrice || 0);
      console.log("EQAM found - Variant ID:", eqamVariantId, "Price:", eqamPrice);
    }

    const selectedHeater = document.querySelector('input[name="heater"]:checked');
    if (selectedHeater) {
      currentConfiguration.heater = selectedHeater.dataset.variantId;
      currentConfiguration.needsEqam = selectedHeater.dataset.needsEqam === "true";

      if (currentConfiguration.needsEqam && selectedHeater.dataset.eqamVariantId) {
        eqamVariantId = selectedHeater.dataset.eqamVariantId;
        eqamPrice = parseFloat(selectedHeater.dataset.eqamPrice || 0);
        console.log("EQAM dynamically set from heater:", eqamVariantId, eqamPrice);
      }

      updateEqamDisplay();
      updateHeaterOptions();
    }
  }

  function handleGlassChange(selectedGlassInput) {
    currentConfiguration.glass = selectedGlassInput.dataset.glassVariantId;
    currentConfiguration.glassType = selectedGlassInput.dataset.glassType || "jacuzzi";

    selectCarbForGlass(currentConfiguration.glass);
    const carbInput = document.querySelector('input[name="carb-injector"]:checked');
    currentConfiguration.carb = carbInput ? carbInput.dataset.carbVariantId : null;

    const glassType = currentConfiguration.glassType;

    console.log("Glass changed to:", {
      glass: selectedGlassInput.dataset.glassVariantId,
      glassType: glassType,
      carb: currentConfiguration.carb,
    });

    updateGlassCarbDisplay();

    mouthpieceGateSync();

    updateSummary();
    updateMainProductMedia();
  }

  function selectCarbForGlass(glassVariantId) {
    // Option B: carb caps are no longer paired to glass. The carb step stays HIDDEN
    // (empty-note only) until a glass is chosen; once it is, reveal ALL carb variants
    // and let the customer pick. This helper is called on glass change and on init.
    const list = document.getElementById("carb-options-list");
    const note = document.getElementById("carb-injector-empty-note");
    const hasGlass = !!(glassVariantId && String(glassVariantId).trim());
    // display:contents — the wrapper generates no box, so the carb cards sit
    // directly in the .config-options grid (the skin's 2-up card layout).
    if (list) list.style.display = hasGlass ? "contents" : "none";
    if (note) note.style.display = hasGlass ? "none" : "";
  }

  function handleCarbInjectorChange(selectedCarbInput) {
    // Option B: honor whatever carb the user picked; no glass-pairing revert.
    currentConfiguration.carb = selectedCarbInput.dataset.carbVariantId;
    mouthpieceGateSync();
    updateSummary();
    updateMainProductMedia();
  }

  // ============================================
// GLASS + CARB CAP DISPLAY MANAGEMENT
// ============================================

function updateGlassCarbDisplay() {
  // Option B: keep the carb list revealed/hidden in sync with the current glass choice.
  const glassInput = document.querySelector('input[name="glass"]:checked');
  selectCarbForGlass(glassInput ? glassInput.dataset.glassVariantId : null);
}

function mouthpieceGateSync() {
  // Option B sequencing: the mouthpiece step stays hidden (empty-note only) until a
  // carb cap is selected. Once a carb is chosen, reveal the per-glass mouthpiece
  // options WITHOUT auto-selecting one — the shopper picks explicitly, so the 3D
  // view keeps showing partial builds until the full chain is genuinely complete.
  const note = document.getElementById("mouthpiece-empty-note");
  const carbChecked = document.querySelector('input[name="carb-injector"]:checked');
  if (carbChecked) {
    if (note) note.style.display = "none";
    updateMouthpieceVisibility(currentConfiguration.glassType);
    updateMouthpieceOptions(currentConfiguration.glassType);
    return;
  }
  if (note) note.style.display = "";
  document.querySelectorAll(".config-option[data-mouthpiece-type]").forEach((el) => {
    el.style.display = "none";
    const input = el.querySelector("input");
    if (input && input.checked) input.checked = false;
  });
  currentConfiguration.mouthpiece = null;
  updateAdapterDisplay();
}

  // ============================================
  // MOUTHPIECE MANAGEMENT
  // ============================================

  function mouthpieceNeedsJacuzziAdapter() {
    const mpInput = document.querySelector('input[name="mouthpiece"]:checked');
    const t = mpInput?.dataset?.mouthpieceType || "";
    return t === "glass" || t === "hookah";
  }

  function mouthpieceNeedsSkyriseAdapter() {
    // Skyrise: Silicone is the native fit — every other mouthpiece (zirconia,
    // glass, hookah hose) requires the Skyrise adapter. No mouthpiece selected
    // yet means no adapter yet.
    const mpInput = document.querySelector('input[name="mouthpiece"]:checked');
    const t = mpInput?.dataset?.mouthpieceType || "";
    return !!t && t !== "silicone";
  }

  /**
   * Skyrise: adapter for every mouthpiece EXCEPT Silicone (the native fit).
   * Jacuzzi: Jacuzzi adapter only for glass or hookah mouthpieces.
   * Sets currentConfiguration.needsAdapter, adapterVariantId, adapterPrice.
   */
  function computeAdapterState() {
    const glass = currentConfiguration.glassType;
    if (glass === "skyrise" && mouthpieceNeedsSkyriseAdapter()) {
      const el = document.getElementById("adapter-display-skyrise");
      if (el) {
        currentConfiguration.needsAdapter = true;
        adapterVariantId = el.dataset.adapterVariantId;
        adapterPrice = parseFloat(el.dataset.adapterPrice || 0);
      } else {
        currentConfiguration.needsAdapter = false;
        adapterVariantId = null;
        adapterPrice = 0;
      }
      return;
    }
    if (glass === "jacuzzi" && mouthpieceNeedsJacuzziAdapter()) {
      const el = document.getElementById("adapter-display-jacuzzi");
      if (el) {
        currentConfiguration.needsAdapter = true;
        adapterVariantId = el.dataset.adapterVariantId;
        adapterPrice = parseFloat(el.dataset.adapterPrice || 0);
      } else {
        currentConfiguration.needsAdapter = false;
        adapterVariantId = null;
        adapterPrice = 0;
      }
      return;
    }
    currentConfiguration.needsAdapter = false;
    adapterVariantId = null;
    adapterPrice = 0;
  }

  function updateMouthpieceVisibility(glassType) {
    const mouthpieceOptions = document.querySelectorAll(
      ".config-option[data-mouthpiece-type]"
    );
    const adapterSkyrise = document.getElementById("adapter-display-skyrise");
    const adapterJacuzzi = document.getElementById("adapter-display-jacuzzi");
    if (adapterSkyrise) adapterSkyrise.style.display = "none";
    if (adapterJacuzzi) adapterJacuzzi.style.display = "none";

    mouthpieceOptions.forEach((optionContainer) => {
      const mouthpieceType = optionContainer.dataset.mouthpieceType;

      if (glassType === "jacuzzi") {
        if (mouthpieceType === "silicone") {
          optionContainer.style.display = "none";
          const input = optionContainer.querySelector("input");
          if (input && input.checked) {
            input.checked = false;
          }
        } else {
          optionContainer.style.display = "block";
        }
      } else {
        optionContainer.style.display = "block";
      }
    });

    // NO auto-select: the shopper must explicitly choose a mouthpiece so the 3D
    // media chain progresses through partials (engine → heater → glass) instead of
    // jumping to a complete-build lookup the moment a carb cap is picked. Just sync
    // state to whatever remains checked after visibility changes — e.g. switching to
    // Jacuzzi hides + unchecks a previously chosen Silicone mouthpiece.
    const checkedMouthpiece = document.querySelector(
      'input[name="mouthpiece"]:checked'
    );
    currentConfiguration.mouthpiece = checkedMouthpiece
      ? checkedMouthpiece.dataset.variantId
      : null;
    updateAdapterDisplay();

    updateContinueButtons();
  }

  function updateMouthpieceOptions(glassType) {
    const mouthpieceOptions = document.querySelectorAll('input[name="mouthpiece"]');
    const sky = document.getElementById("adapter-display-skyrise");
    const jac = document.getElementById("adapter-display-jacuzzi");

    mouthpieceOptions.forEach((option) => {
      const label = option.closest(".config-option");

      if (!label || label.style.display === "none") return;

      const existingNote = label.querySelector(".auto-included-note");
      if (existingNote) existingNote.remove();

      const mpType = option.dataset.mouthpieceType || "";

      if (glassType === "skyrise" && mpType && mpType !== "silicone" && sky) {
        let adapterTitle = "Adapter";
        const adapterTitleElement = sky.querySelector(".option-title");
        if (adapterTitleElement) {
          const titleClone = adapterTitleElement.cloneNode(true);
          const badge = titleClone.querySelector(".auto-included-badge");
          if (badge) badge.remove();
          adapterTitle = titleClone.textContent.trim();
        }
        const autoIncludedNote = document.createElement("span");
        autoIncludedNote.className = "auto-included-note";
        autoIncludedNote.style.cssText =
          "font-size: 11px; color: #000; display: block; margin-top: 4px; font-weight: 500;";
        autoIncludedNote.innerHTML = `✓ ${adapterTitle} will be included`;
        const optionInfo = label.querySelector(".option-info");
        if (optionInfo) optionInfo.appendChild(autoIncludedNote);
      }

      if (glassType === "jacuzzi" && (mpType === "glass" || mpType === "hookah") && jac) {
        let adapterTitle = "Adapter";
        let adapterSku = "";
        const adapterTitleElement = jac.querySelector(".option-title");
        if (adapterTitleElement) {
          const titleClone = adapterTitleElement.cloneNode(true);
          const badge = titleClone.querySelector(".auto-included-badge");
          if (badge) badge.remove();
          adapterTitle = titleClone.textContent.trim();
        }
        adapterSku = jac.dataset.adapterSku || "";
        const autoIncludedNote = document.createElement("span");
        autoIncludedNote.className = "auto-included-note";
        autoIncludedNote.style.cssText =
          "font-size: 11px; color: #000; display: block; margin-top: 4px; font-weight: 500;";
        autoIncludedNote.innerHTML = `✓ ${adapterTitle} will be included`;
        const optionInfo = label.querySelector(".option-info");
        if (optionInfo) optionInfo.appendChild(autoIncludedNote);
      }
    });

    updateAdapterDisplay();
  }

  function updateAdapterDisplay() {
    const sky = document.getElementById("adapter-display-skyrise");
    const jac = document.getElementById("adapter-display-jacuzzi");
    computeAdapterState();
    // Same as EQAM: bundled SKUs stay in hidden panels; mouthpiece rows show the subline note.
    if (sky) sky.style.display = "none";
    if (jac) jac.style.display = "none";
  }

  function handleMouthpieceChange(selectedInput) {
    currentConfiguration.mouthpiece = selectedInput.dataset.variantId;
    updateAdapterDisplay();
    updateSummary();
    updateMainProductMedia();
  }

  // ============================================
  // SUMMARY OVERLAY
  // ============================================

  function setSummaryExpanded(expanded) {
    isExpanded = expanded;
    allArrowBtns.forEach((b) => b.classList.toggle("expanded", isExpanded));
    if (expandedPanel) {
      expandedPanel.classList.toggle("visible", isExpanded);
    }
  }

  const allArrowBtns = document.querySelectorAll(".summary-arrow-btn");

  allArrowBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      setSummaryExpanded(!isExpanded);
      msrpAutoExpandedOnDock = false;
      console.log("Summary toggled:", isExpanded);
    });
  });

  if (customBtn) {
    customBtn.addEventListener("click", () => {
      const configSection = document.getElementById("configurator-categories");
      if (configSection) {
        const offset = getConfiguratorScrollOffset();
        const elementPosition = configSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    });
  }

  // ============================================
  // MOBILE MSRP DOCK (fixed until section bottom)
  // ============================================
  const MSRP_FIXED_BOTTOM_OFFSET = 100;
  const MSRP_DOCK_UNDOCK_HYSTERESIS = 48;
  let msrpDockCompactHeight = 56;
  let msrpDockScrollThreshold = null;
  let msrpDockRaf = null;
  let msrpDockResizeObserver = null;

  function getConfiguratorMsrpElements() {
    return {
      msrp: document.querySelector(".configurator-msrp-column"),
      slot: document.getElementById("configurator-msrp-slot"),
      dock: document.getElementById("configurator-msrp-dock"),
      anchor: document.getElementById("configurator-msrp-anchor"),
    };
  }

  function measureMsrpCompactHeight(msrp) {
    const compactBar = msrp?.querySelector(".summary-compact-bar");
    if (!compactBar) return msrpDockCompactHeight;

    const styles = getComputedStyle(compactBar);
    const verticalPadding =
      (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
    const border =
      (parseFloat(styles.borderTopWidth) || 0) +
      (parseFloat(styles.borderBottomWidth) || 0);
    const measured = Math.ceil(compactBar.offsetHeight + verticalPadding + border);
    return measured > 0 ? measured : msrpDockCompactHeight;
  }

  function invalidateMsrpDockThreshold() {
    msrpDockScrollThreshold = null;
  }

  function getMsrpDockScrollThreshold() {
    if (msrpDockScrollThreshold !== null) return msrpDockScrollThreshold;

    const { msrp, anchor, dock } = getConfiguratorMsrpElements();
    if (!msrp) return Infinity;

    msrpDockCompactHeight = measureMsrpCompactHeight(msrp);

    // Prefer anchor; fall back to dock if anchor is display:none (e.g. base.css div:empty rule)
    let referenceRect = anchor?.getBoundingClientRect();
    if (!referenceRect || (referenceRect.top === 0 && referenceRect.bottom === 0)) {
      referenceRect = dock?.getBoundingClientRect();
    }
    if (!referenceRect || (referenceRect.top === 0 && referenceRect.bottom === 0)) {
      return Infinity;
    }

    const docTop = referenceRect.top + window.scrollY;
    msrpDockScrollThreshold = docTop - getMsrpFixedBarTop();
    return msrpDockScrollThreshold;
  }

  function ensureMsrpFloatingRoot() {
    let root = document.getElementById("configurator-msrp-floating-root");
    if (!root) {
      root = document.createElement("div");
      root.id = "configurator-msrp-floating-root";
      root.className = "configurator-msrp-floating-root";
      document.body.appendChild(root);
    }
    return root;
  }

  function getMsrpSectionVisibility() {
    const section = getConfiguratorMsrpSection();
    if (!section) {
      return { inView: false, pastSection: false, beforeStart: false };
    }

    const rect = section.getBoundingClientRect();

    return {
      inView: rect.bottom > 0 && rect.top < window.innerHeight,
      pastSection: rect.bottom <= 0,
      beforeStart: rect.top >= window.innerHeight,
    };
  }

  function getConfiguratorMsrpSection() {
    return document.getElementById("configurator-msrp-dock")?.closest("section") || null;
  }

  function getMsrpFixedBarTop() {
    return window.innerHeight - MSRP_FIXED_BOTTOM_OFFSET - msrpDockCompactHeight;
  }

  function computeMsrpShouldDock(isDocked) {
    const { msrp, anchor } = getConfiguratorMsrpElements();
    if (!msrp || !anchor) return false;

    const visibility = getMsrpSectionVisibility();
    if (visibility.beforeStart) return false;

    const threshold = getMsrpDockScrollThreshold();
    const scrollY = window.scrollY;
    const slack = MSRP_DOCK_UNDOCK_HYSTERESIS;

    if (isDocked) {
      return scrollY >= threshold - slack;
    }

    return scrollY >= threshold;
  }

  function syncMsrpVisibility() {
    const { msrp } = getConfiguratorMsrpElements();
    if (!msrp || !isMobileAccordion()) return;

    const visibility = getMsrpSectionVisibility();
    const isDocked = msrp.classList.contains("is-docked");
    const hideBar =
      !visibility.inView ||
      visibility.beforeStart ||
      (visibility.pastSection && !isDocked);

    msrp.classList.toggle("is-msrp-hidden", hideBar);
  }

  function placeMsrpFloating(msrp) {
    ensureMsrpFloatingRoot().appendChild(msrp);
  }

  function placeMsrpInDock(msrp, dock, anchor) {
    if (anchor) {
      anchor.insertAdjacentElement("afterend", msrp);
    } else if (dock) {
      dock.appendChild(msrp);
    }
  }

  function setMsrpDocked(shouldDock) {
    const { msrp, dock, anchor } = getConfiguratorMsrpElements();
    if (!msrp) return;

    const isDocked = msrp.classList.contains("is-docked");
    if (isDocked === shouldDock) return;

    if (shouldDock) {
      msrp.classList.remove("is-floating");
      msrp.classList.add("is-docked");
      placeMsrpInDock(msrp, dock, anchor);

      if (!isExpanded) {
        requestAnimationFrame(() => {
          if (!msrp.classList.contains("is-docked")) return;
          setSummaryExpanded(true);
          msrpAutoExpandedOnDock = true;
        });
      }
      return;
    }

    msrp.classList.remove("is-docked");
    msrp.classList.add("is-floating");
    placeMsrpFloating(msrp);

    if (msrpAutoExpandedOnDock) {
      requestAnimationFrame(() => {
        if (!msrp.classList.contains("is-floating")) return;
        setSummaryExpanded(false);
        msrpAutoExpandedOnDock = false;
      });
    }
  }

  function syncMsrpPlacement() {
    const { msrp, slot, dock, anchor } = getConfiguratorMsrpElements();
    if (!msrp || !slot || !dock) return;

    if (!isMobileAccordion()) {
      msrp.classList.remove("is-floating", "is-docked", "is-msrp-hidden");
      msrpAutoExpandedOnDock = false;
      if (msrp.parentElement !== slot) {
        slot.appendChild(msrp);
      }
      dock.hidden = true;
      return;
    }

    dock.hidden = false;

    if (msrp.classList.contains("is-docked")) {
      msrp.classList.remove("is-floating");
      placeMsrpInDock(msrp, dock, anchor);
    } else {
      msrp.classList.add("is-floating");
      msrp.classList.remove("is-docked");
      placeMsrpFloating(msrp);
    }

    syncMsrpVisibility();
  }

  function updateMsrpDockState() {
    if (!isMobileAccordion()) return;

    const { msrp, anchor } = getConfiguratorMsrpElements();
    if (!msrp || !anchor) {
      if (msrp) {
        setMsrpDocked(false);
        syncMsrpPlacement();
      }
      return;
    }

    msrpDockCompactHeight = measureMsrpCompactHeight(msrp);

    const isDocked = msrp.classList.contains("is-docked");
    const shouldDock = computeMsrpShouldDock(isDocked);

    setMsrpDocked(shouldDock);
    syncMsrpPlacement();
  }

  function scheduleMsrpDockStateUpdate() {
    if (msrpDockRaf) cancelAnimationFrame(msrpDockRaf);
    msrpDockRaf = requestAnimationFrame(() => {
      msrpDockRaf = null;
      updateMsrpDockState();
    });
  }

  function refreshConfiguratorMsrpDock() {
    invalidateMsrpDockThreshold();

    const { msrp } = getConfiguratorMsrpElements();
    if (msrp) {
      msrpDockCompactHeight = measureMsrpCompactHeight(msrp);
    }

    if (!isMobileAccordion()) {
      syncMsrpPlacement();
      return;
    }

    updateMsrpDockState();
  }

  function initConfiguratorMsrpDock() {
    const { msrp } = getConfiguratorMsrpElements();
    if (!msrp) return;

    msrpDockCompactHeight = measureMsrpCompactHeight(msrp);

    if (isMobileAccordion()) {
      msrp.classList.remove("is-docked", "is-msrp-hidden");
      msrp.classList.add("is-floating");
      placeMsrpFloating(msrp);
    }

    refreshConfiguratorMsrpDock();

    window.addEventListener("scroll", scheduleMsrpDockStateUpdate, {
      passive: true,
    });
    window.addEventListener("resize", refreshConfiguratorMsrpDock);
    MOBILE_ACCORDION_MQ.addEventListener("change", refreshConfiguratorMsrpDock);

    if (typeof ResizeObserver !== "undefined") {
      const compactBar = msrp.querySelector(".summary-compact-bar");
      if (compactBar) {
        msrpDockResizeObserver = new ResizeObserver(refreshConfiguratorMsrpDock);
        msrpDockResizeObserver.observe(compactBar);
      }

      const categoriesRoot = document.getElementById("configurator-categories");
      if (categoriesRoot) {
        const categoriesObserver = new ResizeObserver(() => {
          invalidateMsrpDockThreshold();
          scheduleMsrpDockStateUpdate();
        });
        categoriesObserver.observe(categoriesRoot);
      }
    }
  }

  // ============================================
  // UPDATE SUMMARY
  // ============================================

  /** Hide accessory rows that duplicate auto-bundled variants (carb cap, EQAM, mouthpiece adapter). */
  function refreshRedundantAccessoryRows() {
    const bundled = new Set();
    const carbInp = document.querySelector('input[name="carb-injector"]:checked');
    if (carbInp?.dataset?.carbVariantId) {
      bundled.add(String(carbInp.dataset.carbVariantId));
    }
    if (currentConfiguration.needsEqam && eqamVariantId) {
      bundled.add(String(eqamVariantId));
    }
    if (currentConfiguration.needsAdapter && adapterVariantId) {
      bundled.add(String(adapterVariantId));
    }
    document.querySelectorAll('input[name="accessories"]').forEach((inp) => {
      const row = inp.closest(".config-option");
      const vid = String(inp.dataset.variantId || "");
      const hide = Boolean(vid) && bundled.has(vid);
      if (row) row.style.display = hide ? "none" : "";
      if (hide && inp.checked) inp.checked = false;
    });
    currentConfiguration.accessories = Array.from(
      document.querySelectorAll('input[name="accessories"]:checked')
    ).map((cb) => cb.dataset.variantId);
  }

function updateSummary() {
  if (!breakdownContainer) return;

  breakdownContainer.innerHTML = "";
  let total = basePrice;

  computeAdapterState();
  refreshRedundantAccessoryRows();

  // Process items in specific order (remove 'accessories' from here)
  const itemsOrder = ["engine", "heater", "glass", "mouthpiece"];

  itemsOrder.forEach((itemName) => {
    if (itemName === "glass") {
      const glassInput = document.querySelector('input[name="glass"]:checked');
      const carbInput = document.querySelector('input[name="carb-injector"]:checked');
      if (!glassInput || !carbInput) return;

      const glassPrice = parseFloat(glassInput.dataset.glassPrice || 0);
      const carbPrice = parseFloat(carbInput.dataset.carbPrice || 0);
      const glassTitle = glassInput.dataset.glassTitle || "Glass";
      const glassSku = glassInput.dataset.glassSku || "";

      let carbTitle =
        carbInput.dataset.carbVariantTitle ||
        carbInput.dataset.carbTitle ||
        "Carb Cap";
      const carbSku = carbInput.dataset.carbSku || "";

      total += glassPrice;
      const glassItem = document.createElement("div");
      glassItem.className = "summary-item";
      glassItem.innerHTML = `
        <div class="summary-item-info">
          <div class="summary-item-category">Glass</div>
          <div class="summary-item-selection">${glassTitle}</div>
        </div>
        <div class="summary-item-price">$${glassPrice.toFixed(2)}</div>
      `;
      breakdownContainer.appendChild(glassItem);

      total += carbPrice;
      const carbItem = document.createElement("div");
      carbItem.className = "summary-item";
      carbItem.innerHTML = `
        <div class="summary-item-info">
          <div class="summary-item-category">Carb Cap</div>
          <div class="summary-item-selection">${carbTitle} <small style="color: rgba(255,255,255,0.55);">• Auto-included</small></div>
        </div>
        <div class="summary-item-price">+ $${carbPrice.toFixed(2)}</div>
      `;
      breakdownContainer.appendChild(carbItem);

      return;
    }

    const input = document.querySelector(`input[name="${itemName}"]:checked`);

    if (!input) return;

    // Handle regular items
    const price = parseFloat(input.dataset.price || 0);
    total += price;

    const categoryName = itemName
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const optionLabel = input
      .closest(".config-option")
      ?.querySelector(".option-title");
    const selection = optionLabel ? optionLabel.textContent.trim() : "N/A";

    const item = document.createElement("div");
    item.className = "summary-item";
    item.innerHTML = `
      <div class="summary-item-info">
        <div class="summary-item-category">${categoryName}</div>
        <div class="summary-item-selection">${selection}</div>
      </div>
      <div class="summary-item-price">$${price.toFixed(2)}</div>
    `;
    breakdownContainer.appendChild(item);

    // Add EQAM right after Heater if needed
    if (
      itemName === "heater" &&
      currentConfiguration.needsEqam &&
      eqamPrice > 0
    ) {
      total += eqamPrice;

      const eqamDisplay = document.getElementById("eqam-display");
      let eqamTitle = "EQ Heater for Crucibles";
      let eqamSku = "EQAM";

      if (eqamDisplay) {
        const eqamTitleElement = eqamDisplay.querySelector(".option-title");
        if (eqamTitleElement) {
          eqamTitle = eqamTitleElement.textContent.trim();
        }
        eqamSku = eqamDisplay.dataset.eqamSku || "EQAM";
      }

      const eqamItem = document.createElement("div");
      eqamItem.className = "summary-item";
      eqamItem.innerHTML = `
        <div class="summary-item-info">
          <div class="summary-item-category">Heater Assembly</div>
          <div class="summary-item-selection">${eqamTitle} <small style="color: rgba(255,255,255,0.55);">• Auto-included</small></div>
        </div>
        <div class="summary-item-price">+ $${eqamPrice.toFixed(2)}</div>
      `;
      breakdownContainer.appendChild(eqamItem);
    }

    // Add Adapter right after Mouthpiece if needed
    if (
      itemName === "mouthpiece" &&
      currentConfiguration.needsAdapter &&
      adapterPrice > 0
    ) {
      total += adapterPrice;

      const adapterEl =
        currentConfiguration.glassType === "skyrise"
          ? document.getElementById("adapter-display-skyrise")
          : document.getElementById("adapter-display-jacuzzi");
      let adapterTitle = "Adapter";
      let adapterSku = "";

      if (adapterEl) {
        const adapterTitleElement = adapterEl.querySelector(".option-title");
        if (adapterTitleElement) {
          const titleClone = adapterTitleElement.cloneNode(true);
          const badge = titleClone.querySelector(".auto-included-badge");
          if (badge) badge.remove();
          adapterTitle = titleClone.textContent.trim();
        }
        adapterSku = adapterEl.dataset.adapterSku || "";
      }

      const adapterItem = document.createElement("div");
      adapterItem.className = "summary-item";
      adapterItem.innerHTML = `
        <div class="summary-item-info">
          <div class="summary-item-category">Mouthpiece Adapter</div>
          <div class="summary-item-selection">${adapterTitle} <small style="color: rgba(255,255,255,0.55);">• Auto-included</small></div>
        </div>
        <div class="summary-item-price">+ $${adapterPrice.toFixed(2)}</div>
      `;
      breakdownContainer.appendChild(adapterItem);
    }
  });

  // Handle accessories (checkboxes) - group them with total price
  const accessoryInputs = document.querySelectorAll(
    'input[name="accessories"]:checked'
  );
  if (accessoryInputs.length > 0) {
    let accessoriesTotal = 0;
    accessoryInputs.forEach((input) => {
      accessoriesTotal += parseFloat(input.dataset.price || 0);
    });

    total += accessoriesTotal;

    const accessoriesHeader = document.createElement("div");
    accessoriesHeader.className = "summary-item";
    accessoriesHeader.innerHTML = `
    <div class="summary-item-info">
      <div class="summary-item-category">Accessories</div>
    </div>
    <div class="summary-item-price">+ $${accessoriesTotal.toFixed(2)}</div>
  `;
    breakdownContainer.appendChild(accessoriesHeader);

    accessoryInputs.forEach((input) => {
      const optionLabel = input
        .closest(".config-option")
        ?.querySelector(".option-title");
      const selection = optionLabel ? optionLabel.textContent.trim() : "N/A";
      const item = document.createElement("div");
      item.className = "summary-item summary-sub-item";
      item.innerHTML = `
      <div class="summary-item-info">
        <div class="summary-item-selection">${selection}</div>
      </div>
    `;
      breakdownContainer.appendChild(item);
    });
  }

  const formattedTotal = total.toFixed(2);
  const compactPrice = document.getElementById("compact-price");
  const expandedTotalPrice = document.getElementById("expanded-total-price");
  const actionPrice = document.getElementById("action-price");

  if (compactPrice) compactPrice.textContent = `$${formattedTotal}`;
  if (expandedTotalPrice) expandedTotalPrice.textContent = `$${formattedTotal}`;
  if (actionPrice) actionPrice.textContent = `$${formattedTotal}`;

  console.log("Configuration:", currentConfiguration);
}


// ============================================
// ADD TO CART
// ============================================

if (addToCartBtn) {
  addToCartBtn.addEventListener("click", async () => {
    const buildId = `config-${Date.now()}`;
    const items = [];

    console.log("=== Starting Add to Cart ===");

    // Get all selected radio buttons (engine, heater, glass, carb-injector, mouthpiece)
    const selectedRadios = document.querySelectorAll(
      'input[type="radio"]:checked:not([name="accessories"])'
    );

    // Process radio button selections
    selectedRadios.forEach((input) => {
      const name = input.name;

      if (name === "glass") {
        const glassVariantId = parseInt(input.dataset.glassVariantId, 10);
        if (glassVariantId && !isNaN(glassVariantId)) {
          console.log(`Adding Glass: ${glassVariantId}`);
          items.push({
            id: glassVariantId,
            quantity: 1,
            properties: { _build_id: buildId },
          });
        }
        return;
      }

      if (name === "carb-injector") {
        const carbVariantId = parseInt(input.dataset.carbVariantId, 10);
        if (carbVariantId && !isNaN(carbVariantId)) {
          console.log(`Adding Carb Cap: ${carbVariantId}`);
          items.push({
            id: carbVariantId,
            quantity: 1,
            properties: { _build_id: buildId },
          });
        }
        return;
      }

      // Handle other radio selections (engine, heater, mouthpiece)
      const variantId = parseInt(input.dataset.variantId, 10);
      if (variantId && !isNaN(variantId)) {
        console.log(`Adding ${name}: ${variantId}`);
        items.push({
          id: variantId,
          quantity: 1,
          properties: { _build_id: buildId },
        });
      }
    });

    // Handle accessories (checkboxes)
    const accessoryInputs = document.querySelectorAll(
      'input[name="accessories"]:checked'
    );
    accessoryInputs.forEach((input) => {
      const variantId = parseInt(input.dataset.variantId, 10);
      if (variantId && !isNaN(variantId)) {
        console.log(`Adding Accessory: ${variantId}`);
        items.push({
          id: variantId,
          quantity: 1,
          properties: { _build_id: buildId },
        });
      }
    });

    computeAdapterState();

    // Add EQAM automatically if required
    if (currentConfiguration?.needsEqam && eqamVariantId) {
      console.log("Adding EQAM:", eqamVariantId);
      items.push({
        id: parseInt(eqamVariantId, 10),
        quantity: 1,
        properties: {
          _build_id: buildId,
          _category: "heater_assembly",
          _auto_added: "true",
        },
      });
    }

    // Add adapter automatically if required
    if (currentConfiguration?.needsAdapter && adapterVariantId) {
      console.log("Adding Adapter:", adapterVariantId);
      items.push({
        id: parseInt(adapterVariantId, 10),
        quantity: 1,
        properties: {
          _build_id: buildId,
          _category: "mouthpiece_adapter",
          _auto_added: "true",
        },
      });
    }

    // Stop if nothing selected
    if (items.length === 0) {
      alert("Please select all required options before adding to cart.");
      return;
    }

    console.log("Items prepared for cart:", items);

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = "Adding...";

    try {
      /* ONE COMPLETE BUILD AT A TIME (Hande 2026-08-21: "yeah it should add 1 complete
         build at a time").

         This handler ADDS line items, it never replaced them, so configuring twice left
         BOTH builds in the cart. Seen in the live cart: a four-day-old Gunmetal build was
         still sitting there and a fresh Onyx build stacked on top, so checkout showed 13
         items and $1,013.98 for what the buybar had priced at $484.99. Survivable when the
         last step was "Review your build"; actively misleading now that it goes straight to
         checkout.

         Every line this handler creates carries a _build_id property, so clearing exactly
         the lines that HAVE one removes any previous configuration and nothing else — a
         standalone accessory or vaporizer added from a normal product page has no
         _build_id and survives untouched. Quantity 0 via /cart/update.js is Shopify's own
         remove-line call; the variants themselves are not affected.

         Best-effort by design: if the clear fails we still add. One stale line is a worse
         cart than intended, but a dead Add To Cart button is worse than either. */
      try {
        const currentCart = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
        }).then((r) => r.json());

        const staleUpdates = {};
        (currentCart.items || []).forEach((line) => {
          if (line && line.properties && line.properties._build_id) {
            staleUpdates[line.key] = 0;
          }
        });

        if (Object.keys(staleUpdates).length) {
          console.log(
            "Clearing previous build line(s):",
            Object.keys(staleUpdates).length
          );
          const clearRes = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ updates: staleUpdates }),
          });
          if (!clearRes.ok) {
            console.warn(
              "Could not clear previous build; adding anyway:",
              clearRes.status
            );
          }
        }
      } catch (clearError) {
        console.warn("Could not clear previous build; adding anyway:", clearError);
      }

      // Add all selected items to Shopify cart
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const errorBody = await response.text();
        console.error("Shopify add.js error:", errorBody);
        throw new Error(`Failed to add items: ${response.status}`);
      }

      const result = await response.json();
      console.log("Items added successfully:", result);

      /* Hande 2026-08-21: the builder's final step is now "Continue to checkout", not
         "Review your build". When the customer arrives through that button the intent is
         explicit, so go to checkout rather than opening the drawer and asking them to
         press a second button. The flag is set by the final-step handler in
         sections/eq-bav-config-skin.liquid and cleared here, so a plain Add To Cart press
         still opens the drawer as before.

         Deliberately placed AFTER response.ok and the json parse: a failed add falls to
         the catch below and the customer stays on the page with their build intact. */
      if (window.__eqcCheckoutAfterAdd) {
        window.__eqcCheckoutAfterAdd = false;
        addToCartBtn.textContent = "Redirecting…";
        window.location.href = "/checkout";
        return;
      }

      // Refresh and open cart drawer
      const cart_drawer = document.querySelector("cart-drawer");
      if (cart_drawer) {
        cart_drawer.refresh();
        cart_drawer.open();
      }

      addToCartBtn.disabled = false;
      addToCartBtn.textContent = "Add To Cart";
    } catch (error) {
      console.error("Add to Cart error:", error);
      window.__eqcCheckoutAfterAdd = false;
      alert("Error adding to cart. Please try again.");

      addToCartBtn.disabled = false;
      addToCartBtn.textContent = "Add To Cart";
    }
  });
}


  // ============================================
  // URL CONFIG — shareable links
  // ============================================

  // Push current configuration into the URL as query params so the page can
  // be bookmarked/shared with a specific pre-selected setup.
  // Preserves all existing params (e.g. ?view=configurator) and uses
  // history.replaceState so no extra history entries are created.
  function pushConfigUrl() {
    if (typeof history === "undefined") return;
    try {
      const url = new URL(window.location.href);
      const p = url.searchParams;
      if (currentConfiguration.engine)     p.set("engine",     currentConfiguration.engine);
      if (currentConfiguration.heater)     p.set("heater",     currentConfiguration.heater);
      if (currentConfiguration.glass)      p.set("glass",      currentConfiguration.glass);
      if (currentConfiguration.carb)       p.set("carb",       currentConfiguration.carb);
      if (currentConfiguration.mouthpiece) p.set("mouthpiece", currentConfiguration.mouthpiece);
      const acc = (currentConfiguration.accessories || []).filter(Boolean);
      if (acc.length) p.set("accessories", acc.join(","));
      else p.delete("accessories");
      history.replaceState(null, "", url.toString());
    } catch (_) {}
  }

  // On page load, read URL params and apply the specified configuration.
  // Calls the existing handler functions directly (not dispatchEvent) so
  // accordion auto-advance and scroll are not triggered during init.
  function applyUrlConfig() {
    const p = new URLSearchParams(window.location.search);
    const engineId     = p.get("engine");
    const heaterId     = p.get("heater");
    const glassId      = p.get("glass");
    const carbId       = p.get("carb");
    const mouthpieceId = p.get("mouthpiece");
    const accessoryIds = (p.get("accessories") || "").split(",").filter(Boolean);

    // Nothing to do — leave defaults as-is.
    if (!engineId && !heaterId && !glassId && !mouthpieceId && !accessoryIds.length) return;

    // Apply glass first: it auto-selects a carb and adjusts mouthpiece visibility.
    if (glassId) {
      const el = document.querySelector(`input[name="glass"][data-glass-variant-id="${glassId}"]`);
      if (el) { el.checked = true; handleGlassChange(el); }
    }

    // Override the auto-selected carb if the URL specifies one explicitly.
    if (carbId) {
      const el = document.querySelector(`input[name="carb-injector"][data-carb-variant-id="${carbId}"]`);
      if (el) { el.checked = true; handleCarbInjectorChange(el); }
    }

    if (engineId) {
      const el = document.querySelector(`input[name="engine"][data-variant-id="${engineId}"]`);
      if (el) {
        el.checked = true;
        currentConfiguration.engine = el.dataset.variantId;
      }
    }

    if (heaterId) {
      const el = document.querySelector(`input[name="heater"][data-variant-id="${heaterId}"]`);
      if (el) { el.checked = true; handleHeaterChange(el); }
    }

    // Apply mouthpiece after glass so visibility is already correct.
    if (mouthpieceId) {
      const el = document.querySelector(`input[name="mouthpiece"][data-variant-id="${mouthpieceId}"]`);
      if (el) { el.checked = true; handleMouthpieceChange(el); }
    }

    // Accessories are checkboxes — check each one and sync the array.
    accessoryIds.forEach((variantId) => {
      const el = document.querySelector(`input[name="accessories"][data-variant-id="${variantId}"]`);
      if (el) {
        el.checked = true;
        if (!currentConfiguration.accessories.includes(variantId)) {
          currentConfiguration.accessories.push(variantId);
        }
      }
    });

    // Re-render summary + media to reflect the URL-specified config.
    updateSummary();
    updateMainProductMedia();
  }

  // ============================================
  // EVENT LISTENERS
  // ============================================

  document.querySelectorAll('input[name="engine"]').forEach((input) => {
    input.addEventListener("change", () => {
      currentConfiguration.engine = input.dataset.variantId;
      updateSummary();
      updateMainProductMedia();
      handleStepOptionChange(input);
      pushConfigUrl();
    });
  });

  document.querySelectorAll('input[name="heater"]').forEach((input) => {
    input.addEventListener("change", () => {
      handleHeaterChange(input);
      handleStepOptionChange(input);
      pushConfigUrl();
    });
  });

  document.querySelectorAll('input[name="glass"]').forEach((input) => {
    input.addEventListener("change", () => {
      handleGlassChange(input);
      handleStepOptionChange(input);
      pushConfigUrl();
    });
  });

  document.querySelectorAll('input[name="carb-injector"]').forEach((input) => {
    input.addEventListener("change", () => {
      handleCarbInjectorChange(input);
      handleStepOptionChange(input);
      pushConfigUrl();
    });
  });

  document.querySelectorAll('input[name="mouthpiece"]').forEach((input) => {
    input.addEventListener("change", () => {
      handleMouthpieceChange(input);
      handleStepOptionChange(input);
      pushConfigUrl();
    });
  });

  document.addEventListener("change", (e) => {
    if (e.target.matches(".config-option input")) {
      const inputName = e.target.name;

      if (
        inputName === "engine" ||
        inputName === "heater" ||
        inputName === "glass" ||
        inputName === "carb-injector" ||
        inputName === "mouthpiece"
      )
        return;

      if (e.target.type === "checkbox") {
        currentConfiguration.accessories = Array.from(
          document.querySelectorAll('input[name="accessories"]:checked')
        ).map((cb) => cb.dataset.variantId);
      } else {
        currentConfiguration[inputName] = e.target.dataset.variantId;
      }

      updateSummary();
      updateMainProductMedia();
      pushConfigUrl();
    }
  });



// ============================================
// CONFIGURATION TO MEDIA NAME (variant metafield: custom.asset_part_label)
// ============================================

function stripPartLabelSpaces(value) {
  if (value == null || typeof value !== "string") return "";
  return value.trim().replace(/\s+/g, "");
}

function titleFallbackPartLabel(name) {
  if (!name || typeof name !== "string") return "";
  const normalized = name.replace(/^EQ\s+/i, "").trim();
  return stripPartLabelSpaces(normalized);
}

/** Uses data-asset-part-label from the variant; falls back to option title (EQ-stripped, no spaces). */
function partLabelFromOptionInput(input) {
  if (!input) return "";
  const fromMetafield = stripPartLabelSpaces(input.dataset.assetPartLabel);
  if (fromMetafield) return fromMetafield;
  const title = input.closest(".config-option")?.querySelector(".option-title")?.textContent?.trim();
  return titleFallbackPartLabel(title || "");
}

/** Reads custom.asset_part_label for a variant from preloaded configurator product JSON (EQAM, etc.). */
function lookupVariantAssetPartLabel(variantId) {
  if (variantId == null || variantId === "") return "";
  const want = String(variantId).trim();
  const products = configuratorProductsData?.products;
  if (!products || typeof products !== "object") return "";
  const keys = Object.keys(products);
  for (let i = 0; i < keys.length; i++) {
    const vars = products[keys[i]]?.variants;
    if (!Array.isArray(vars)) continue;
    for (let j = 0; j < vars.length; j++) {
      const v = vars[j];
      if (String(v?.id) !== want) continue;
      const label = stripPartLabelSpaces(v?.asset_part_label);
      if (label) return label;
    }
  }
  return "";
}

/* Returns the ORDERED part labels for what the customer has actually chosen, e.g.
   ["BlackEngine","QuartzCrucible","Atomizer"]. Split out from generateConfigurationName so
   the fallback chain can drop parts from the end one at a time (see
   findBestPartialConfiguratorMedia). Never invents a part that is not selected. */
function generateConfigurationPartList() {
  const parts = [];

  // 1. Engine
  const engineInput = document.querySelector('input[name="engine"]:checked');
  if (engineInput) {
    const label = partLabelFromOptionInput(engineInput);
    if (label) parts.push(label);
  }

  // 2. Heater
  const heaterInput = document.querySelector('input[name="heater"]:checked');
  if (heaterInput) {
    const label = partLabelFromOptionInput(heaterInput);
    if (label) parts.push(label);
  }

  // 3. EQAM if needed — only EQAM variant custom.asset_part_label (DOM on #eqam-display, then JSON by EQAM variant id from display / heater / state).
  if (currentConfiguration.needsEqam) {
    const eqamDisplay = document.getElementById("eqam-display");
    const eqVariantId = String(
      eqamDisplay?.dataset?.eqamVariantId ||
        heaterInput?.dataset?.eqamVariantId ||
        eqamVariantId ||
        ""
    ).trim();
    let eqamPart = stripPartLabelSpaces(eqamDisplay?.dataset?.assetPartLabel);
    if (!eqamPart && eqVariantId) eqamPart = lookupVariantAssetPartLabel(eqVariantId);
    if (eqamPart) parts.push(eqamPart);
  }

  // 4. Glass
  const glassInput = document.querySelector('input[name="glass"]:checked');
  if (glassInput) {
    let glassPart = stripPartLabelSpaces(glassInput.dataset.glassAssetPartLabel);
    if (!glassPart && glassInput.dataset.glassTitle) {
      glassPart = titleFallbackPartLabel(glassInput.dataset.glassTitle);
    }
    if (glassPart) parts.push(glassPart);
  }

  // 5. Mouthpiece
  const mouthpieceInput = document.querySelector('input[name="mouthpiece"]:checked');
  if (mouthpieceInput) {
    const label = partLabelFromOptionInput(mouthpieceInput);
    if (label) parts.push(label);
  }

  // 6. Carb cap (after mouthpiece — same order as before)
  const carbInput = document.querySelector('input[name="carb-injector"]:checked');
  if (carbInput) {
    let carbPart = stripPartLabelSpaces(carbInput.dataset.carbAssetPartLabel);
    if (!carbPart) {
      const carbTitle =
        carbInput.dataset.carbVariantTitle || carbInput.dataset.carbTitle || "";
      carbPart = titleFallbackPartLabel(carbTitle || "");
    }
    if (carbPart) parts.push(carbPart);
  }

  return parts.map((part) => stripPartLabelSpaces(part)).filter(Boolean);
}

function generateConfigurationName() {
  const configName = "EQ" + generateConfigurationPartList().join("+");

  console.log("Generated config name:", configName);
  return configName;
}

function getEngineProductIdsForMediaSearch() {
  const ids = [];
  const seen = new Set();

  const add = (id) => {
    const sid = String(id || "").trim();
    if (!sid || seen.has(sid)) return;
    seen.add(sid);
    ids.push(sid);
  };

  [
    configuratorProductsData?.engineProductIds,
    configuratorProductsData?.mediaProductIds,
    [configuratorProductsData?.templateProductId],
  ].forEach((source) => {
    if (Array.isArray(source)) source.forEach(add);
  });

  const engineInput = document.querySelector('input[name="engine"]:checked');
  add(engineInput?.dataset?.productId);

  return ids;
}

function findMatchingMediaInProducts() {
  const configName = generateConfigurationName();
  return searchProductsForMedia(getEngineProductIdsForMediaSearch(), configName);
}

// ============================================
// LOAD CONFIGURATOR PRODUCTS DATA
// ============================================

let configuratorProductsData = { products: {} };

function loadConfiguratorData() {
  try {
    const dataScript = document.getElementById('configurator-products-data');
    if (dataScript) {
      configuratorProductsData = JSON.parse(dataScript.textContent);
      console.log(' Loaded configurator products data:', configuratorProductsData);
      console.log('Products loaded:', Object.keys(configuratorProductsData.products).length);
    } else {
      console.warn('Configurator products data script not found');
    }
  } catch (error) {
    console.error('Error loading configurator products data:', error);
  }
}

loadConfiguratorData();

// ============================================
// SEARCH FOR MATCHING MEDIA (GLB filename)
// ============================================

function extractGlbFilenameFromUrl(url) {
  if (url == null || url === "") return "";
  const noQuery = String(url).trim().split("?")[0].split("#")[0];
  const name = noQuery.split("/").pop() || "";
  try {
    return decodeURIComponent(name);
  } catch (e) {
    return name;
  }
}

function normalizeConfiguratorMatchKey(value) {
  if (value == null || value === "") return "";
  let s = String(value).trim();
  s = s.split(/[\\/]/).pop() || s;
  s = s.split("?")[0].split("#")[0];
  try {
    s = decodeURIComponent(s.replace(/\+/g, "%2B"));
  } catch (e) {
    try {
      s = decodeURIComponent(s);
    } catch (err) {
      /* noop */
    }
  }
  return s
    .replace(/\.(glb|usdz|gltf)$/i, "")
    /* Shopify appends a UUID when an uploaded filename collides with one already in the
       store, so re-uploading a corrected export lands as
       EQBlackEngine_QuartzCrucible_Atomizer_172eebe7-1803-4b93-89c4-81e51b0a9bc6.glb.
       That suffix is storage bookkeeping, not part of the build spec, and stripping it is
       what makes "just re-upload the fixed model" work with no theme edit. Anchored to the
       end and to the exact 8-4-4-4-12 hex shape so it cannot eat a real part name. */
    .replace(
      /[-_][0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
      ""
    )
    .replace(/[\s+_]+/g, "")
    .toLowerCase();
}

function looksLikeConfiguratorModelFilename(name) {
  const key = normalizeConfiguratorMatchKey(name);
  return key.startsWith("eq") && key.length > 4;
}

function getModelGlbFilename(media) {
  if (!media || media.media_type !== "model") return "";

  if (media.model_filename) {
    return String(media.model_filename).trim();
  }

  const sources = Array.isArray(media.sources) ? media.sources : [];
  const glbSource = sources.find(
    (source) => String(source.format || "").toLowerCase() === "glb"
  );
  if (glbSource?.url) {
    return extractGlbFilenameFromUrl(glbSource.url);
  }

  for (const source of sources) {
    const candidate = extractGlbFilenameFromUrl(source?.url);
    if (looksLikeConfiguratorModelFilename(candidate)) {
      return candidate;
    }
  }

  for (const source of sources) {
    const candidate = extractGlbFilenameFromUrl(source?.url);
    if (candidate) return candidate;
  }

  return "";
}

function configNameMatchesGlbFilename(configName, filename) {
  const configKey = normalizeConfiguratorMatchKey(configName);
  const fileKey = normalizeConfiguratorMatchKey(filename);
  if (!configKey || !fileKey) return false;
  return configKey === fileKey;
}

async function searchProductsForMedia(engineProductIds, configName) {
  const configKey = normalizeConfiguratorMatchKey(configName);
  const availableFilenames = [];
  const scope = new Set((engineProductIds || []).map((id) => String(id)));
  let bestMatch = null;
  let bestMatchId = -1;

  if (scope.size === 0) {
    console.warn("No engine product IDs available for 3D model search");
    return null;
  }

  for (const productId in configuratorProductsData.products) {
    if (!scope.has(String(productId))) continue;

    const productData = configuratorProductsData.products[productId];

    if (productData.media && productData.media.length > 0) {
      for (const media of productData.media) {
        if (media.media_type !== "model") continue;

        const filename = getModelGlbFilename(media);
        if (!filename) {
          console.log(`Media ${media.id} (${media.media_type}) has no GLB filename - SKIPPING`);
          continue;
        }

        availableFilenames.push(filename);

        if (!configNameMatchesGlbFilename(configName, filename)) continue;

        /* Do NOT return the first hit. A build can be attached to the product more than
           once -- e.g. EQBlackEngine+QuartzCrucible+Atomizer.glb (8 Jul, stray geometry)
           and EQBlackEngine_QuartzCrucible_Atomizer.glb (3 Aug, clean) -- and the matcher
           strips both "+" and "_", so the two are indistinguishable by key. Media IDs
           increase with upload time, so the highest ID is the most recent upload: prefer
           it. That makes "re-upload a fixed model" the whole fix, with no theme edit and
           nothing to delete. Retired media (see the geometry guard) are skipped outright. */
        if (isConfiguratorMediaRetired(media)) {
          console.log(" skipping retired media", media.id, filename);
          continue;
        }

        var candidateId = Number(media.id) || 0;
        if (!bestMatch || candidateId > bestMatchId) {
          bestMatch = { media: media, product: productData };
          bestMatchId = candidateId;
        }
      }
    }
  }

  if (bestMatch) {
    console.log(" FOUND MATCHING MEDIA!", getModelGlbFilename(bestMatch.media), bestMatch.media.id);
    return bestMatch;
  }

  console.log(" No matching media found on engine product(s)");
  console.log(" Engine product IDs searched:", Array.from(scope));
  console.log(" Expected config key:", configKey);
  console.log(" Available model filenames:", availableFilenames);
  return null;
}

// ============================================
// SWITCH TO MEDIA / UNAVAILABLE STATE
// ============================================

function getConfiguratorMediaGallery() {
  const gallery = document.querySelector("media-gallery");
  // Suppress Dawn's setActiveMedia auto-scroll: give the target slide a no-op
  // scrollIntoView the first time so switching configurator models never yanks
  // the viewport. (Patch applied once, then delegates to the original.)
  if (gallery && gallery.setActiveMedia && !gallery.__eqcNoAutoScroll) {
    gallery.__eqcNoAutoScroll = true;
    const origSetActiveMedia = gallery.setActiveMedia.bind(gallery);
    gallery.setActiveMedia = function (mediaId, prepend) {
      try {
        const slide = gallery.querySelector(`[data-media-id="${mediaId}"]`);
        if (slide && !Object.prototype.hasOwnProperty.call(slide, "scrollIntoView")) {
          slide.scrollIntoView = function () {};
        }
      } catch (e) { /* non-fatal */ }
      return origSetActiveMedia(mediaId, prepend);
    };
  }
  return gallery;
}

function getConfiguratorMediaSlider() {
  const gallery = getConfiguratorMediaGallery();
  return gallery ? gallery.querySelector(".product__media-list") : null;
}

function hideAllConfiguratorGallerySlides() {
  const slider = getConfiguratorMediaSlider();
  if (!slider) return;
  slider.querySelectorAll(".product__media-item").forEach((slide) => {
    slide.classList.remove("is-active");
    slide.style.display = "none";
  });
}

window.applyConfiguratorBuild = async function (buildName, opts) {
  // Selects the builder's actual option inputs from a config-name string
  // ("EQPurpleEngine+QuartzCrucible+Atomizer+SkyriseGlass+GlassMouthpiece+SiliconeCarbCap").
  // Same normalization as the 3D matcher. Order matters: engine -> heater -> glass ->
  // mouthpiece, with settle delays, because glass drives mouthpiece visibility and the
  // carb cap auto-pairs. "Atomizer" and carb tokens are skipped (auto-included/paired).
  opts = opts || {};
  if (!buildName || typeof buildName !== "string") return false;
  if (window.__eqcApplyingBuild) return false; // an apply is already in flight -- ignore double-clicks
  var tokens = buildName.split("+").map(function (t) {
    return normalizeConfiguratorMatchKey(t);
  }).filter(Boolean);
  if (tokens.length && tokens[0].indexOf("eq") === 0) tokens[0] = tokens[0].slice(2);
  var SKIP = { atomizer: 1, zirconiacarbcap: 1, siliconecarbcap: 1 };
  var CATS = ["engine", "heater", "glass", "mouthpiece"];
  var applied = 0;

  function labelFor(cat, input) {
    // Glass and carb inputs do NOT carry data-asset-part-label -- they use their own
    // data-glass-*/data-carb-* attributes (the same sources generateConfigurationName
    // reads). Reading partLabelFromOptionInput for glass fell through to the option
    // title ("EQ Jacuzzi Bubbler") and never matched a build token, so presets applied
    // everything except glass and the viewport stayed on the hero media.
    var raw = "";
    if (cat === "glass") {
      raw = input.dataset.glassAssetPartLabel ||
        titleFallbackPartLabel(input.dataset.glassTitle || "");
    } else if (cat === "carb-injector") {
      raw = input.dataset.carbAssetPartLabel ||
        titleFallbackPartLabel(input.dataset.carbVariantTitle || input.dataset.carbTitle || "");
    }
    if (!raw) raw = partLabelFromOptionInput(input) || "";
    return normalizeConfiguratorMatchKey(raw);
  }
  function pick(cat, remaining) {
    var inputs = document.querySelectorAll('input[name="' + cat + '"]');
    for (var i = 0; i < inputs.length; i++) {
      var label = labelFor(cat, inputs[i]);
      if (!label) continue;
      if (remaining.indexOf(label) !== -1) return { input: inputs[i], token: label };
    }
    return null;
  }
  function settle(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  var remaining = tokens.filter(function (t) { return !SKIP[t]; });
  window.__eqcApplyingBuild = true;
  try {
    for (var c = 0; c < CATS.length; c++) {
      var hit = pick(CATS[c], remaining);
      if (hit && !hit.input.checked) {
        // checked + synthetic change instead of .click(): click() focuses the input,
        // and the browser scrolling the focused element into view fights the smooth
        // scroll-to-builder that just started.
        hit.input.checked = true;
        hit.input.dispatchEvent(new Event("change", { bubbles: true }));
        applied += 1;
        await settle(120);
      } else if (hit) {
        applied += 1;
      }
      if (hit) remaining.splice(remaining.indexOf(hit.token), 1);
    }
    // Accessories (persona add-ons like Carry Case / Hot Knife / Dab Tool):
    // matched by fuzzy token against the accessory checkbox product titles, so
    // "Carry Case" matches "EQ Carry Case" and "Hot Knife" will match
    // "DaVinci Hot Knife" once that product is wired into the accessories list.
    // Unknown tokens no-op harmlessly.
    if (opts.accessories) {
      var accTokens = String(opts.accessories).split(",").map(function (t) {
        return normalizeConfiguratorMatchKey(t);
      }).filter(Boolean);
      for (var a = 0; a < accTokens.length; a++) {
        var accInputs = document.querySelectorAll('input[name="accessories"]');
        for (var b = 0; b < accInputs.length; b++) {
          var accLabel = normalizeConfiguratorMatchKey(
            accInputs[b].dataset.productTitle || partLabelFromOptionInput(accInputs[b]) || ""
          );
          if (!accLabel) continue;
          if (accLabel.indexOf(accTokens[a]) !== -1 || accTokens[a].indexOf(accLabel) !== -1) {
            if (!accInputs[b].checked) {
              accInputs[b].checked = true;
              accInputs[b].dispatchEvent(new Event("change", { bubbles: true }));
              applied += 1;
              await settle(80);
            }
            break;
          }
        }
      }
    }
  } finally {
    window.__eqcApplyingBuild = false; // never leave media updates suppressed
  }
  // Scroll to the builder AFTER the loop: during the loop the step-UI auto-advance
  // is suppressed, so this single smooth scroll runs uncontested. The configured
  // anchor ("#shopify-section-main") does not exist on JSON templates -- section
  // wrappers are id'd "shopify-section-<template>__main" -- so resolve defensively.
  if (opts.scroll !== false) {
    var target = null;
    try { target = document.querySelector(opts.anchor || ""); } catch (e) { target = null; }
    if (!target) target = document.querySelector('[id^="shopify-section-"][id$="__main"]');
    if (!target) target = document.querySelector(".configurator-main-product");
    if (target) {
      // Signal the config-skin anti-jump guard to stand down while this intentional
      // scroll plays out (smooth scroll over ~4000px takes well under 1.5s).
      window.__eqcScrollIntent = true;
      setTimeout(function () { window.__eqcScrollIntent = false; }, 1600);
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
  // The one and only media/summary refresh for this apply -- runs with the complete
  // build in place, so exactly one model swap happens.
  try {
    updateSummary();
    updateMainProductMedia();
  } catch (e) { /* non-fatal: viewport refresh is advisory */ }
  return applied > 0;
};

function getConfiguratorHeroBuildName() {
  // Editable in the theme editor: main-product-configurator setting "hero_build",
  // emitted into #configurator-products-data as heroBuild. Empty string disables.
  var name = configuratorProductsData && configuratorProductsData.heroBuild;
  return typeof name === "string" && name.trim() ? name.trim() : "";
}

/* Hande 2026-08-21: "in the first step, the engines need to show only the engines."

   On first load nothing is checked, so the fallback below used to jump straight to the FULL
   hero build -- a finished rig with glass, mouthpiece and carb cap -- while the panel is
   still only asking for an engine colour. The engine on its own is the honest first frame.

   heroBuild is an editor setting ("EQBlackEngine+ZirconiaCrucible+Atomizer+...") whose FIRST
   part is always the engine, so deriving the engine from it needs no second setting and can
   never drift out of sync with the hero. */
function getConfiguratorHeroEngineName() {
  var hero = getConfiguratorHeroBuildName();
  if (!hero) return "";
  var first = String(hero).split("+")[0];
  return first && first.trim() ? first.trim() : "";
}

/* Longest axis, in the units model-viewer reports from getDimensions(), that a healthy asset
   in this library measures. Sampled across every shape of build: engine alone 2.45, engine +
   crucible + atomizer 2.45, a full six-part rig 2.45 x 4.03 x 1.68. Nothing good comes near
   20; the known-bad files measure 1219.66. See the guard in watchConfiguratorModelLoad. */
var CONFIGURATOR_MAX_SANE_MODEL_SIZE = 20;

/* Media whose GLB downloaded and parsed without error but whose geometry is unusable.
   Keyed on MEDIA ID, not filename: the same build can be attached twice (an older broken
   upload and a newer clean re-upload), and "+" and "_" normalize to the same match key, so
   a filename-keyed registry would retire the good copy along with the bad one. Without any
   registry the fallback would re-pick the bad copy on the next refresh and loop. */
var configuratorRetiredMediaIds = new Set();

function isConfiguratorMediaRetired(media) {
  var id = media && media.id != null ? String(media.id) : "";
  return !!id && configuratorRetiredMediaIds.has(id);
}

/* Hande 2026-08-21: "the only problem is the second step when you get to the crucibles -
   then it doesn't display the engine + selected crucible?"

   Cause: when the exact build had no model of its own, the code jumped ALL the way to the
   full hero rig. So Onyx + Zirconia Crucible -- a pair whose combined GLB is not in the
   library -- displayed a finished rig with glass and mouthpiece attached: the opposite of
   what the panel was asking about, and impossible to read as "your engine and your crucible".

   Fix: degrade ONE part at a time. Try the exact selection, then the selection minus its last
   part, and so on down to the engine. Every partial name is a real filename in this library
   (EQBlackEngine_QuartzCrucible_Atomizer, then EQBlackEngine), so the viewer always lands on
   the closest TRUE representation of what has been chosen. It only ever drops parts -- it
   never adds one the customer has not picked. */
async function findBestPartialConfiguratorMedia(parts) {
  var list = Array.isArray(parts) ? parts : [];
  var scope = getEngineProductIdsForMediaSearch();
  for (var end = list.length; end > 0; end--) {
    var name = "EQ" + list.slice(0, end).join("+");
    var found = null;
    try {
      found = await searchProductsForMedia(scope, name);
    } catch (e) {
      found = null;
    }
    if (found && found.media) return { media: found.media, name: name };
  }
  return null;
}

function configuratorHasCompleteSelection() {
  // The "we're working on a 3D experience" notice must only appear for a build the
  // customer has actually specified. On first load nothing is checked, so an empty
  // build would otherwise trigger it as the first thing on the page.
  return ["engine", "heater", "glass", "mouthpiece"].every(function (slot) {
    return !!document.querySelector('input[name="' + slot + '"]:checked');
  });
}

function showConfiguratorDefaultMedia() {
  // Reverses hideAllConfiguratorGallerySlides(): restore the first gallery slide so an
  // incomplete build shows product media instead of an empty panel.
  var slider = getConfiguratorMediaSlider();
  if (!slider) return;
  var slides = slider.querySelectorAll(".product__media-item");
  if (!slides.length) return;
  slides.forEach(function (slide, i) {
    if (i === 0) slide.style.setProperty("display", "block", "important");
    else slide.style.display = "none";
    slide.classList.toggle("is-active", i === 0);
  });
}

function hideConfiguratorModelUnavailable() {
  const el = document.getElementById("configurator-model-unavailable");
  if (el) el.hidden = true;
}

function showConfiguratorModelUnavailable(configName) {
  if (window.pauseAllMedia) window.pauseAllMedia();
  hideAllConfiguratorGallerySlides();

  const el = document.getElementById("configurator-model-unavailable");
  if (el) el.hidden = false;

  // if (configName) alert(configName);
}

function watchConfiguratorModelLoad(targetSlide, configName, mediaId) {
  let attempts = 0;
  const maxAttempts = 50;

  function attach() {
    const productModel = targetSlide.querySelector("product-model");
    if (productModel && !productModel.getAttribute("loaded")) {
      if (typeof productModel.loadContent === "function") {
        productModel.loadContent();
      }
    }

    const modelViewer = targetSlide.querySelector("model-viewer");
    if (!modelViewer) {
      attempts += 1;
      if (attempts < maxAttempts) setTimeout(attach, 100);
      return;
    }

    // Auto-reveal the 3D scene. Shopify ships model-viewer with a poster attribute
    // pointing at an auto-generated preview JPEG whose background is baked white —
    // no CSS can tint it. Removing the poster and revealing immediately lets the
    // transparent WebGL canvas sit directly on the stage plate.
    modelViewer.removeAttribute("poster");
    modelViewer.setAttribute("reveal", "auto");
    if (typeof modelViewer.dismissPoster === "function") {
      try { modelViewer.dismissPoster(); } catch (e) { /* keep going */ }
    }
    const uiPoster = targetSlide.querySelector(".shopify-model-viewer-ui__poster");
    if (uiPoster) uiPoster.style.display = "none";

    // Unlock direct interaction: Dawn's model-viewer UI ships the viewer disabled
    // behind a click-to-activate poster. Strip those attributes and neutralize the
    // wrapper's pause behavior so the 3D stage is live immediately.
    modelViewer.removeAttribute("toggleable");
    if (modelViewer.hasAttribute("disabled")) {
      modelViewer.removeAttribute("disabled");
      modelViewer.removeAttribute("tabindex");
    }
    const hostProductModel = targetSlide.querySelector("product-model");
    if (hostProductModel && hostProductModel.modelViewerUI) {
      const mvui = hostProductModel.modelViewerUI;
      try { mvui.interacting = true; } catch (e) { /* non-fatal */ }
      if (mvui.toggleable) {
        try { mvui.pause = function () {}; } catch (e) { /* non-fatal */ }
      }
    }

    // Once the 3D scene has actually loaded, retire BOTH preview JPEGs (Dawn renders
    // a modal-opener image and a deferred poster image, each a white-baked photo) so
    // the transparent WebGL canvas is the only thing on the stage. Gated on the load
    // event so a failed model never leaves an empty viewport.
    modelViewer.addEventListener(
      "load",
      () => {
        /* GEOMETRY SANITY GUARD (Hande 2026-08-21: the crucible step "looks empty").

           Four GLBs in this library -- EQ<colour>Engine_QuartzCrucible_Atomizer, all four
           engine colours -- download and parse with no error, but each carries a second
           cluster of stray geometry roughly 1,130 units away from the product. model-viewer
           auto-frames the whole bounding box, so the product renders about three pixels wide
           and the stage reads as EMPTY rather than as broken. Measured with getDimensions():
           1219.66 x 74.10 x 143.01, against 2.45 x 2.12 x 1.39 for the same build in
           Zirconia. Confirmed by raycasting the rendered scene -- hits only at x = -607 and
           x = +523, nothing in between -- and reproduced in a bare model-viewer outside this
           page, so it is the asset and not the gallery.

           Those four files need re-exporting. Until they are, a frame that is honest but
           incomplete (the engine on its own, via the fallback chain) beats a blank stage, so
           the asset is retired for this session and the chain re-runs. Remove this guard once
           the exports are replaced -- it is a net, not a feature. */
        try {
          const dims = modelViewer.getDimensions ? modelViewer.getDimensions() : null;
          const longest = dims ? Math.max(dims.x, dims.y, dims.z) : 0;
          if (longest > CONFIGURATOR_MAX_SANE_MODEL_SIZE && mediaId) {
            console.warn(
              "configurator: unusable model geometry (longest axis " +
                longest.toFixed(1) +
                "), retiring media " +
                mediaId +
                ":",
              targetSlide.dataset.mediaFilename || configName
            );
            configuratorRetiredMediaIds.add(String(mediaId));
            updateMainProductMedia();
            return;
          }
        } catch (e) {
          /* a measurement must never block the reveal */
        }

        targetSlide
          .querySelectorAll(".deferred-media__poster, modal-opener")
          .forEach((el) => { el.style.display = "none"; });
      },
      { once: true }
    );

    modelViewer.addEventListener(
      "error",
      () => {
        showConfiguratorModelUnavailable(configName);
      },
      { once: true }
    );
  }

  attach();
}

function switchToMedia(media, configName) {
  const resolvedConfigName = configName || generateConfigurationName();
  console.log("🎬 Switching to media:", media);

  const mediaGallery = getConfiguratorMediaGallery();
  if (!mediaGallery) return console.error("Media gallery not found");

  const slider = getConfiguratorMediaSlider();
  if (!slider) return console.error(" Media list not found");

  hideConfiguratorModelUnavailable();

  if (window.pauseAllMedia) window.pauseAllMedia();

  hideAllConfiguratorGallerySlides();

  const mediaFilenameKey = normalizeConfiguratorMatchKey(getModelGlbFilename(media));
  let targetSlide = slider.querySelector(`[data-media-id*="config-${media.id}"]`);

  if (!targetSlide) {
    // The widened matcher can return media owned by the configurator (template)
    // product itself. Those render as standard Dawn slides — data-media-id ends in
    // "-<id>" with no "config-" prefix — so resolve them too before giving up.
    targetSlide = slider.querySelector(`[data-media-id$="-${media.id}"]`);
  }

  if (!targetSlide && mediaFilenameKey) {
    const configuratorSlides = slider.querySelectorAll('[data-configurator-media="true"]');
    for (const slide of configuratorSlides) {
      const slideFilenameKey = normalizeConfiguratorMatchKey(slide.dataset.mediaFilename || "");
      if (slideFilenameKey && slideFilenameKey === mediaFilenameKey) {
        targetSlide = slide;
        break;
      }
    }
  }

  if (!targetSlide) {
    console.error("Could not find slide for media:", media);
    showConfiguratorModelUnavailable(resolvedConfigName);
    return;
  }

  targetSlide.classList.add("is-active");
  // dynamic.css hides every non-config slide with display:none!important, so a plain
  // inline "" or "block" loses the cascade and the model renders into an invisible
  // slide (blank viewport). Inline !important is the only thing that outranks it,
  // and it is harmless on config slides.
  targetSlide.style.setProperty("display", "block", "important");

  const productModel = targetSlide.querySelector("product-model");
  if (productModel && media.media_type === "model") {
    if (!productModel.loadContent) {
      productModel.loadContent = function () {
        if (this.getAttribute("loaded")) return;

        const template = this.querySelector("template");
        if (!template) return;

        const content = template.content.firstElementChild.cloneNode(true);
        this.setAttribute("loaded", true);
        this.appendChild(content);

        if (window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: () => {
                if (window.Shopify.ModelViewerUI) {
                  this.modelViewerUI = new window.Shopify.ModelViewerUI(
                    this.querySelector("model-viewer")
                  );
                }
              },
            },
          ]);
        }
      };
    }

    /* THE ACTUAL "EMPTY VIEWER" BUG (Hande 2026-08-21: "the viewer doesn't display a bunch
       of the options - when you pass to crucibles it looks empty").

       Above, we only DEFINE loadContent as a fallback — nothing ever CALLS it. Each slide
       holds its model-viewer inside a <template> in <product-model>; until loadContent()
       expands that template, the slide has no model-viewer at all. So the sequence was:
       hideAllConfiguratorGallerySlides() hides the previously-loaded slide (taking its
       live model-viewer out of view), the correct target slide is revealed — and it is
       EMPTY, because its template was never expanded. Verified live: the target slide had
       the right data-media-filename and .is-active, while the only model-viewer in the DOM
       still carried the PREVIOUS build's glb.

       setActiveMedia() was being relied on to trigger the load and does not do so here.
       Expanding it explicitly is the fix. `loaded` is Dawn's own guard, so this is
       idempotent; focus=false keeps the page from jumping to the viewer on every swap. */
    if (typeof productModel.loadContent === "function" && !productModel.getAttribute("loaded")) {
      try {
        productModel.loadContent(false);
      } catch (e) {
        try { productModel.loadContent(); } catch (e2) {
          console.warn("configurator: loadContent failed for slide", targetSlide, e2);
        }
      }
    }
  }

  console.log("Media switched successfully");

  const mediaId = targetSlide.dataset.mediaId;
  if (mediaGallery.setActiveMedia) {
    setTimeout(() => {
      mediaGallery.setActiveMedia(mediaId, false);
    }, 50);
  }

  setTimeout(() => {
    applyConfiguratorModelViewerTheme(document);
  }, 80);

  if (media.media_type === "model") {
    watchConfiguratorModelLoad(targetSlide, resolvedConfigName, media.id);
  }
}




async function updateMainProductMedia() {
  // While a preset / deep-link build is being applied, every category change fires
  // this handler -- five rapid 3D swaps thrash the gallery (overlapping setActiveMedia
  // timeouts, five ~6.5MB GLB downloads competing) and the viewport blanks or flickers.
  // applyConfiguratorBuild suppresses the intermediates and runs ONE final refresh.
  if (window.__eqcApplyingBuild) return;
  const configName = generateConfigurationName();
  const parts = generateConfigurationPartList();
  // searchProductsForMedia skips media retired by the geometry guard and, where the same
  // build is attached twice, returns the most recent upload.
  const matchingMedia = await findMatchingMediaInProducts();

  if (matchingMedia) {
    console.log(" Found matching media, switching now...");
    switchToMedia(matchingMedia.media, configName);
    return;
  }

  if (configuratorHasCompleteSelection()) {
    // A build the customer has fully specified and we genuinely cannot render deserves the
    // honest "we're working on a 3D experience" notice, not a partial stand-in that would
    // read as the finished product.
    console.warn("No matching media for configuration:", configName);
    showConfiguratorModelUnavailable(configName);
    return;
  }

  if (window.__eqcUrlBuildPending) {
    // A ?build= deep link is being applied; skip the fallbacks while it settles.
    hideConfiguratorModelUnavailable();
    return;
  }

  hideConfiguratorModelUnavailable();

  // Mid-build: show the closest model to what has ACTUALLY been chosen, dropping one part
  // at a time, before considering anything from the hero.
  const partial = await findBestPartialConfiguratorMedia(parts);
  if (partial) {
    switchToMedia(partial.media, partial.name);
    return;
  }

  // Nothing chosen yet (first paint). The engine alone -- the hero rig here would answer a
  // question the panel has not asked.
  const fallbackNames = [];
  const heroEngine = getConfiguratorHeroEngineName();
  const heroName = getConfiguratorHeroBuildName();
  if (heroEngine) fallbackNames.push(heroEngine);
  if (heroName && heroName !== heroEngine) fallbackNames.push(heroName);

  for (const name of fallbackNames) {
    let media = null;
    try {
      media = await searchProductsForMedia(getEngineProductIdsForMediaSearch(), name);
    } catch (e) {
      media = null;
    }
    if (media && media.media) {
      switchToMedia(media.media, name);
      return;
    }
  }

  showConfiguratorDefaultMedia();
}



  // ============================================
  // ACCESSORIES PICKER (3 per page when 4+ options)
  // ============================================

  function initAccessoriesPicker() {
    const picker = document.querySelector("#category-accessories .accessories-picker");
    if (!picker) return;

    const prev = picker.querySelector(".accessories-picker-prev");
    const next = picker.querySelector(".accessories-picker-next");
    if (!prev || !next) return;

    const pageCount = Math.max(
      1,
      parseInt(
        picker.style.getPropertyValue("--acc-pages").trim() ||
          getComputedStyle(picker).getPropertyValue("--acc-pages").trim() ||
          "1",
        10
      ) || 1
    );

    if (pageCount <= 1) {
      return;
    }

    let pageIndex = 0;

    function sync() {
      picker.style.setProperty("--acc-page", String(pageIndex));
      prev.disabled = pageIndex <= 0;
      next.disabled = pageIndex >= pageCount - 1;
      prev.setAttribute("aria-disabled", prev.disabled ? "true" : "false");
      next.setAttribute("aria-disabled", next.disabled ? "true" : "false");
    }

    prev.addEventListener("click", () => {
      pageIndex = Math.max(0, pageIndex - 1);
      sync();
    });
    next.addEventListener("click", () => {
      pageIndex = Math.min(pageCount - 1, pageIndex + 1);
      sync();
    });

    sync();
  }

  function escapeHtmlAttr(str) {
    return String(str ?? "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;");
  }

  function normalizeConfiguratorCdnSrc(url) {
    if (url == null) return "";
    const s = String(url).trim();
    if (!s) return "";
    if (s.startsWith("//")) return `https:${s}`;
    return s;
  }

  function mediaSlideSrcForLightbox(m) {
    let raw = "";
    if (m.preview_image && m.preview_image.src) raw = m.preview_image.src;
    else if (m.media_type === "image" && m.src) raw = m.src;
    else if (m.src) raw = m.src;
    return normalizeConfiguratorCdnSrc(raw);
  }

  function optionRowHasGalleryThumbnail(imgWrap) {
    if (!imgWrap || !imgWrap.querySelector) return false;
    const img = imgWrap.querySelector(":scope > img");
    if (!img) return false;
    const srcAttr = (img.getAttribute("src") || "").trim();
    return (
      !!srcAttr &&
      !/^data:/i.test(srcAttr)
    );
  }

  function imageSlidesFromConfiguratorProduct(product) {
    if (!product || !Array.isArray(product.media)) return [];
    const slides = [];
    const seen = new Set();
    for (const m of product.media) {
      if (m.media_type === "model") continue;
      const url = mediaSlideSrcForLightbox(m);
      if (!url || seen.has(url)) continue;
      seen.add(url);
      slides.push({ src: url, alt: m.alt || product.title || "" });
    }
    return slides;
  }

  function applyConfiguratorModelViewerTheme(root) {
    const scope = root && root.querySelector ? root : document;
    scope.querySelectorAll("model-viewer").forEach((mv) => {
      if (mv.dataset.configuratorEnv !== "1") {
        mv.dataset.configuratorEnv = "1";
        try {
          mv.setAttribute("environment-image", "neutral");
        } catch (e) {
          /* noop */
        }
      }
      mv.style.backgroundColor = "transparent";
    });
  }

  function initConfiguratorModelViewerEnhancements() {
    applyConfiguratorModelViewerTheme(document);
    const root =
      document.getElementById("configurator-categories")?.closest("section") ||
      document.querySelector(".product-configurator") ||
      document.body;
    const obs = new MutationObserver(() => {
      applyConfiguratorModelViewerTheme(document);
    });
    try {
      obs.observe(root, { childList: true, subtree: true });
    } catch (e) {
      /* noop */
    }
  }

  function initConfiguratorOptionLightbox() {
    const modal = document.getElementById("configurator-option-lightbox");
    if (!modal || typeof modal.showModal !== "function") return;

    const categoriesRoot = document.getElementById("configurator-categories");
    if (!categoriesRoot) return;

    function findProductIdFromInput(input) {
      if (!input) return null;
      return (
        input.dataset.productId ||
        input.dataset.carbProductId ||
        input.dataset.glassProductId ||
        null
      );
    }

    categoriesRoot.querySelectorAll(".config-option").forEach((opt) => {
      const input = opt.querySelector(
        'input[type="radio"][data-product-id], input[type="checkbox"][data-product-id], input[type="radio"][data-carb-product-id], input[type="radio"][data-glass-product-id]'
      );
      const imgWrap = opt.querySelector(".option-image");
      if (!input || !imgWrap || imgWrap.querySelector(".config-option__gallery-open")) return;
      if (!optionRowHasGalleryThumbnail(imgWrap)) return;
      const pid = findProductIdFromInput(input);
      if (!pid) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "config-option__gallery-open";
      btn.setAttribute("aria-haspopup", "dialog");
      btn.setAttribute("aria-label", "View product images");
      btn.dataset.productId = pid;
      btn.innerHTML =
        '<span class="config-option__gallery-open-icon" aria-hidden="true">+</span>';
      imgWrap.appendChild(btn);
    });

    const wrapper = document.getElementById("configurator-option-lightbox-wrapper");
    const link = document.getElementById("configurator-option-lightbox-link");
    const heading = document.getElementById("configurator-option-lightbox-heading");
    const closeBtn = modal.querySelector("[data-configurator-lightbox-close]");
    const swiperEl = document.getElementById("configurator-option-lightbox-swiper");
    const nextEl = modal.querySelector(".configurator-option-lightbox__nav--next");
    const prevEl = modal.querySelector(".configurator-option-lightbox__nav--prev");

    function destroyLightboxSwiper() {
      if (optionLightboxSwiper && typeof optionLightboxSwiper.destroy === "function") {
        try {
          optionLightboxSwiper.destroy(true, true);
        } catch (e) {
          /* noop */
        }
      }
      optionLightboxSwiper = null;
    }

    function openLightbox(productId) {
      const products = configuratorProductsData?.products || {};
      const product = products[String(productId)];
      if (!product) return;

      const slides = imageSlidesFromConfiguratorProduct(product);
      if (wrapper) {
        if (slides.length === 0) {
          wrapper.innerHTML =
            '<div class="swiper-slide"><p class="configurator-option-lightbox__empty">No gallery images available for this product.</p></div>';
        } else {
          wrapper.innerHTML = slides
            .map(
              (s) =>
                `<div class="swiper-slide"><img src="${escapeHtmlAttr(s.src)}" alt="${escapeHtmlAttr(
                  s.alt || product.title || ""
                )}" width="1200" height="1200" loading="eager" decoding="async" /></div>`
            )
            .join("");
        }
      }

      if (heading) heading.textContent = product.title || "";
      if (link) {
        if (product.url) {
          link.href = product.url;
          link.hidden = false;
        } else {
          link.hidden = true;
        }
      }

      destroyLightboxSwiper();
      modal.showModal();

      if (typeof Swiper !== "undefined" && swiperEl) {
        optionLightboxSwiper = new Swiper(swiperEl, {
          loop: slides.length > 1,
          watchOverflow: true,
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        });
      }

      requestAnimationFrame(() => {
        if (closeBtn) closeBtn.focus();
      });
    }

    categoriesRoot.addEventListener("click", (e) => {
      const t = e.target.closest(".config-option__gallery-open");
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      openLightbox(t.dataset.productId);
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        if (modal.open) modal.close();
      });
    }

    modal.addEventListener("click", (evt) => {
      if (evt.target === modal && modal.open) modal.close();
    });

    modal.addEventListener("close", () => {
      destroyLightboxSwiper();
      if (wrapper) wrapper.innerHTML = "";
    });
  }

  function initBuilderTooltips() {
    const modal = document.getElementById("builder-tooltip-modal");
    if (!modal || typeof modal.showModal !== "function") return;

    const dataEl = document.getElementById("configurator-builder-tooltips-data");
    let entries = [];
    if (dataEl) {
      try {
        const parsed = JSON.parse(dataEl.textContent || "[]");
        entries = Array.isArray(parsed) ? parsed : [];
      } catch {
        entries = [];
      }
    }

    const titleEl = document.getElementById("builder-tooltip-modal-heading");
    const mediaEl = document.getElementById("builder-tooltip-modal-media");
    const bodyEl = document.getElementById("builder-tooltip-modal-body");
    const closeBtn = modal.querySelector("[data-builder-tooltip-close]");

    let lastTrigger = null;

    function normStep(value) {
      return String(value || "").trim().toLowerCase();
    }

    function findEntry(stepKey) {
      const key = normStep(stepKey);
      return (
        entries.find((e) => normStep(e.step) === key) ||
        (key === "carb-injector"
          ? entries.find((e) => normStep(e.step) === "carb")
          : undefined)
      );
    }

    function setExpanded(activeTrigger) {
      document.querySelectorAll(".builder-tooltip-trigger").forEach((btn) => {
        const on = Boolean(activeTrigger && btn === activeTrigger);
        btn.setAttribute("aria-expanded", on ? "true" : "false");
      });
    }

    function clearModalContent() {
      if (bodyEl) bodyEl.innerHTML = "";
      if (mediaEl) {
        mediaEl.innerHTML = "";
        mediaEl.hidden = true;
      }
    }

    function onModalClose() {
      setExpanded(null);
      clearModalContent();
      if (titleEl) titleEl.textContent = "";
      if (lastTrigger) {
        try {
          lastTrigger.focus();
        } catch {
          /* ignore */
        }
        lastTrigger = null;
      }
    }

    function openFromTrigger(trigger) {
      const step = trigger.getAttribute("data-builder-tooltip-step");
      const entry = findEntry(step);
      if (!entry) return;

      lastTrigger = trigger;

      const header = trigger.closest(".config-category-header");
      const titleSource = header && header.querySelector(".config-category-title");
      if (titleEl) {
        titleEl.textContent = titleSource ? titleSource.textContent.trim() : "";
      }

      clearModalContent();

      if (bodyEl) {
        bodyEl.innerHTML = entry.descriptionHtml || "";
      }

      if (mediaEl && entry.image) {
        const img = document.createElement("img");
        img.className = "builder-tooltip-modal__img";
        img.src = entry.image;
        img.alt = "";
        img.width = 1200;
        img.height = 900;
        img.loading = "lazy";
        img.decoding = "async";
        mediaEl.appendChild(img);
        mediaEl.hidden = false;
      }

      modal.showModal();
      setExpanded(trigger);
      requestAnimationFrame(() => {
        if (closeBtn) closeBtn.focus();
      });
    }

    document.querySelectorAll(".builder-tooltip-trigger").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (isMobileAccordion()) {
          const category = btn.closest(".config-category");
          if (category && category.classList.contains("is-accordion-collapsed")) {
            e.preventDefault();
            e.stopPropagation();
            openAccordionStep(category, { scroll: true, syncNav: true });
            return;
          }
        }

        openFromTrigger(btn);
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        if (modal.open) modal.close();
      });
    }

    modal.addEventListener("click", (evt) => {
      if (evt.target === modal && modal.open) modal.close();
    });

    modal.addEventListener("close", onModalClose);
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function initialize() {
  console.log("Initializing configurator...");

  initConfiguratorNavSticky();
  scheduleConfiguratorNavStickyTop();
  initConfiguratorMsrpDock();

  const compactBar = document.getElementById("summary-compact-bar");

  if (compactBar) compactBar.style.display = "block";

  setSummaryExpanded(false);

  // Initialize EQAM
  initializeEqam();

  // Initialize Glass + Carb (paired in Liquid; JS keeps carb in sync)
  const glassCarbDefault = document.querySelector('input[name="glass"]:checked');
  if (glassCarbDefault) {
    currentConfiguration.glass = glassCarbDefault.dataset.glassVariantId;
    currentConfiguration.glassType = glassCarbDefault.dataset.glassType || "jacuzzi";
    selectCarbForGlass(glassCarbDefault.dataset.glassVariantId);
    const carbPick = document.querySelector('input[name="carb-injector"]:checked');
    currentConfiguration.carb = carbPick ? carbPick.dataset.carbVariantId : null;

  }

  updateGlassCarbDisplay();
  mouthpieceGateSync();

  // Log pre-rendered configurator media
  const configuratorSlides = document.querySelectorAll('[data-configurator-media="true"]');
  // console.log(`📦 Pre-rendered ${configuratorSlides.length} configurator media slides`);
  configuratorSlides.forEach(slide => {
    // console.log(`-${slide.dataset.mediaAlt}`);
  });

  // Initialize engine
  const engineDefault = document.querySelector('input[name="engine"]:checked');
  if (engineDefault) currentConfiguration.engine = engineDefault.dataset.variantId;

  // Initialize mouthpiece
  const mouthpieceDefault = document.querySelector('input[name="mouthpiece"]:checked');
  if (mouthpieceDefault) {
    currentConfiguration.mouthpiece = mouthpieceDefault.dataset.variantId;
  }

  updateAdapterDisplay();
  updateEqamDisplay();
  updateHeaterOptions();
  updateSummary();

  // Switch to the correct media for default configuration
  console.log("🎬 Initializing default media...");
  updateMainProductMedia();

  // Shareable builds: /products/...?build=EQPurpleEngine+QuartzCrucible+...
  try {
    var urlBuild = new URLSearchParams(window.location.search).get("build");
    if (urlBuild) {
      window.__eqcUrlBuildPending = true;
      setTimeout(function () {
        window.applyConfiguratorBuild(urlBuild, { scroll: true });
        window.__eqcUrlBuildPending = false;
      }, 600);
    }
  } catch (e) { /* non-fatal */ }

  initAccessoriesPicker();

  initConfiguratorOptionLightbox();
  initConfiguratorModelViewerEnhancements();

  initBuilderTooltips();

  initMobileAccordion();
  if (isMobileAccordion()) {
    activateMobileAccordion();
  }

  refreshConfiguratorMsrpDock();

  // Apply any URL-param config (overrides defaults above).
  // Must run after all defaults are initialized so handlers have a valid base state.
  applyUrlConfig();

  // Seed the URL with the final config (covers the no-param default load too,
  // so copying the URL from the address bar always gives a shareable link).
  pushConfigUrl();

  console.log("Configurator initialized", currentConfiguration);
}



  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setTimeout(initialize, 100));
  } else {
    setTimeout(initialize, 100);
  }
})();